{
  "T": {
    "sub": "Une marketplace simple et rapide",
    "nav": {
      "home": "Accueil",
      "market": "Annonces",
      "map": "Carte",
      "ai": "Assistant IA",
      "msg": "Messages"
    },
    "home": {
      "immo": "Immobilier",
      "cars": "Voitures",
      "works": "Travaux & Services",
      "others": "Autres",
      "buy": "Achat",
      "rent": "Location",
      "categories": "Catégories",
      "resume": "Reprendre",
      "stats": {
        "items": "Annonces",
        "members": "Membres",
        "chats": "Messages",
        "cats": "Catégories"
      }
    },
    "filters": {
      "all": "Tous",
      "sale": "Vente",
      "rent": "Location",
      "maxPrice": "Prix max",
      "results": "résultat(s)",
      "search": "Rechercher…",
      "cat": "Catégorie",
      "type": "Type de bien",
      "status": "Statut",
      "available": "Disponible",
      "allStatus": "Tous statuts"
    },
    "card": {
      "contact": "Contacter",
      "back": "Retour",
      "sendMsg": "Envoyer un message",
      "km": "km",
      "rooms": "chambres",
      "m2": "m²",
      "perMonth": "/mois",
      "charges": "charges",
      "deposit": "caution",
      "year": "an"
    },
    "status": {
      "active": "Disponible",
      "sold": "Vendu",
      "rented": "Loué",
      "reserved": "Réservé",
      "markAs": "Marquer comme…"
    },
    "publish": {
      "btn": "+ Déposer une annonce",
      "title": "Déposer une annonce",
      "catSelect": "Choisir la catégorie",
      "adType": "Type d'annonce",
      "sale": "Vente",
      "rent": "Location",
      "service": "Service",
      "fields": {
        "title": "Titre *",
        "city": "Ville *",
        "price": "Prix (€) *",
        "rentPrice": "Loyer mensuel (€) *",
        "charges": "Charges (€/mois)",
        "deposit": "Caution (€)",
        "desc": "Description *",
        "propType": "Type de bien",
        "carType": "Type de véhicule",
        "fuel": "Carburant",
        "brand": "Marque",
        "model": "Modèle",
        "year": "Année *",
        "km": "Kilométrage *",
        "area": "Surface (m²) *",
        "rooms": "Chambres",
        "floors": "Étages",
        "parking": "Parking",
        "furnished": "Meublé",
        "condition": "État",
        "gearbox": "Boîte de vitesses",
        "energyClass": "Classe énergétique",
        "power": "Puissance (ch)",
        "urgent": "Urgent",
        "workType": "Type de travaux",
        "otherCat": "Sous-catégorie",
        "bathrooms": "Salle de bain",
        "wc": "WC",
        "cellar": "Cave",
        "balcony": "Balcon / terrasse",
        "floor": "Étage",
        "garden": "Jardin",
        "garage": "Garage",
        "groundFloor": "RDC"
      },
      "yes": "Oui",
      "no": "Non",
      "submit": "Publier l'annonce"
    },
    "auth": {
      "login": "Connexion",
      "register": "Créer un compte",
      "email": "Email",
      "pwd": "Mot de passe",
      "name": "Nom complet",
      "youAre": "Vous êtes",
      "loginBtn": "Se connecter",
      "regBtn": "Créer mon compte",
      "noAcc": "Pas encore de compte ?",
      "hasAcc": "Déjà inscrit ?",
      "signUp": "S'inscrire",
      "signIn": "Se connecter",
      "demo": "Comptes de démo :",
      "roles": [
        "Particulier",
        "Professionnel",
        "Artisan"
      ],
      "e1": "Champs requis.",
      "e2": "Mot de passe trop court.",
      "e3": "Email déjà utilisé.",
      "e4": "Email ou mot de passe incorrect."
    },
    "msg": {
      "title": "Messages",
      "search": "Rechercher…",
      "empty": "Aucune conversation",
      "emptySub": "Contactez un vendeur depuis une annonce",
      "select": "Sélectionnez une conversation",
      "selectSub": "Contactez un annonceur directement depuis une annonce.",
      "you": "Vous",
      "ph": "Message…",
      "send": "➤",
      "start": "Début de la conversation"
    },
    "map": {
      "title": "Carte · Grand-Duché de Luxembourg",
      "hint": "Cliquez sur un pin"
    },
    "ai": {
      "title": "Assistant LANAC",
      "sub": "Propulsé par Claude",
      "ph": "Posez votre question…",
      "sugg": [
        "Appartement à louer Luxembourg",
        "Voiture électrique",
        "Artisan plombier",
        "Maison à vendre Esch"
      ]
    },
    "logout": "Déconnexion",
    "items": "annonce(s)",
    "admin": {
      "nav": "Admin",
      "title": "Panneau Admin",
      "pending": "En attente d'approbation",
      "approve": "✓ Approuver",
      "reject": "✕ Refuser",
      "noPending": "Aucune annonce en attente",
      "reports": "Signalements",
      "openCount": "ouvert(s)",
      "noReports": "Aucun signalement.",
      "treated": "TRAITÉ",
      "by": "Par",
      "noDetails": "Aucun détail ajouté",
      "allListings": "Toutes les annonces",
      "listingCount": "annonces",
      "users": "Utilisateurs",
      "accountCount": "comptes"
    },
    "reviews": {
      "title": "Profil vendeur",
      "noRev": "Aucun avis pour le moment",
      "add": "+ Laisser un avis",
      "pub": "Publier",
      "cancel": "Annuler",
      "note": "Note",
      "yourDone": "✓ Votre avis a été publié",
      "list": "Avis",
      "ph": "Votre commentaire…"
    },
    "ui": {
      "adminOnly": "Espace réservé à l'administration.",
      "notifications": "Notifications",
      "clearAll": "Tout effacer",
      "noNotification": "Aucune notification",
      "back": "Retour",
      "close": "Fermer",
      "actionCancelled": "Action annulée",
      "continue": "Continuer",
      "paused": "En pause — un geste pour reprendre",
      "continueWithApple": "Continuer avec Apple",
      "continueWithGoogle": "Continuer avec Google",
      "orEmail": "ou email",
      "welcome": "Bienvenue sur LANAC",
      "firstRun": "Validez votre email pour pouvoir publier une annonce. Vous restez responsable des informations, photos et messages partagés sur la plateforme.",
      "validateEmail": "Valider mon email",
      "myListings": "Mes annonces",
      "favorites": "Favoris",
      "inbox": "Messages",
      "noResult": "Aucun résultat.",
      "visualSearch": "Recherche visuelle",
      "unavailable": "Non disponible",
      "allCountries": "Tous pays",
      "resetLocation": "Réinitialiser lieu",
      "allSubcats": "Toutes sous-catégories",
      "createAlert": "Créer alerte",
      "nearTitle": "Près de chez vous",
      "nearSub": "Tout ce qui est actif autour de",
      "radius25": "rayon 25 km",
      "homeBack": "Retour accueil",
      "nearSearch": "Chercher près de vous : iPhone, appartement, BMW, jardinier...",
      "all": "Tout",
      "services": "Services",
      "objects": "Objets",
      "nearCount": "annonce(s) proche(s)",
      "clearSearch": "Effacer recherche",
      "noNearResult": "Aucune annonce proche ne correspond à cette recherche.",
      "categories": "Catégories",
      "photoToAdd": "Photo à ajouter",
      "video": "vidéo",
      "evaluateNow": "Évaluer maintenant",
      "deletePhoto": "Supprimer la photo",
      "recentlyViewed": "Vu récemment",
      "report": "Signaler",
      "priceDown": "Prix en baisse",
      "mapLoading": "Chargement de la carte interactive..."
    },
    "badges": {
      "verifiedEmail": "Compte vérifié par email",
      "verified": "Compte vérifié",
      "adminVerified": "Compte vérifié par l'administration",
      "trustTitle": "Score basé sur vérification, avis, historique et signalements",
      "trust": "Confiance",
      "trustedTitle": "Membre fiable selon l'historique LANAC",
      "trusted": "★ Membre de confiance",
      "activityTitle": "Activité estimée selon les annonces récentes",
      "activeRecently": "Actif récemment",
      "activeWeek": "Actif cette semaine",
      "newProfile": "Nouveau profil",
      "established": "Profil établi"
    },
    "terms": {
      "title": "Conditions générales d'utilisation LANAC",
      "account": "Créer mon compte",
      "acceptStrong": "J'accepte les Conditions générales d'utilisation",
      "requiredContinue": "obligatoire pour continuer.",
      "requiredCreate": "obligatoire pour créer un compte.",
      "offers": "J'accepte de recevoir des offres, nouveautés et actualités de LANAC par e-mail.",
      "optional": "(optionnel)",
      "createAccount": "Créer mon compte LANAC",
      "privacyOAuth": "En continuant, vous acceptez également notre Politique de confidentialité conforme au RGPD.",
      "privacyCreate": "En créant votre compte, vous acceptez également notre Politique de confidentialité conforme au RGPD.",
      "p": [
        "1. Éditeur et objet — Lanac est une application éditée par Velyra Technologies S.à r.l., 30 Am Aker, Lamadelaine, Luxembourg. Elle permet la mise en relation entre particuliers et professionnels au Luxembourg.",
        "2. Compte — Vous vous engagez à fournir des informations exactes lors de votre inscription. Vous êtes responsable de la confidentialité de votre mot de passe.",
        "3. Annonces — Vous êtes responsable du contenu publié. Les annonces doivent être légales, véridiques et respectueuses. Lanac se réserve le droit de modérer ou supprimer tout contenu non conforme.",
        "4. Données personnelles — Le responsable de traitement est Velyra Technologies S.à r.l., 30 Am Aker, Lamadelaine, Luxembourg. Vos données sont traitées conformément au RGPD et ne sont jamais vendues à des tiers.",
        "5. Responsabilité — Lanac est un intermédiaire et ne peut être tenu responsable des transactions entre utilisateurs. Restez vigilants et ne partagez jamais de données bancaires via la messagerie.",
        "6. Résiliation — Vous pouvez supprimer votre compte à tout moment depuis les paramètres. Velyra Technologies S.à r.l. peut suspendre tout compte en cas d'abus.",
        "7. Droit applicable — Les présentes conditions sont régies par le droit luxembourgeois.",
        "8. Responsabilité individuelle des utilisateurs — Chaque utilisateur est personnellement et légalement responsable des annonces, descriptions, images, vidéos, messages, prix, coordonnées et autres contenus qu'il publie ou échange via Lanac. Il doit respecter les lois applicables dans son pays ou sa région, garantir qu'il dispose des droits nécessaires sur les contenus partagés et s'abstenir de tout contenu frauduleux, trompeur, illégal, volé, usurpé, interdit, harcelant ou abusif. Lanac agit uniquement comme plateforme intermédiaire de mise en relation et n'est pas le vendeur, l'acheteur, le bailleur, le locataire, le prestataire ou le client. Les transactions, rendez-vous, visites, paiements, échanges et accords restent sous la responsabilité des utilisateurs concernés. Lanac peut retirer un contenu, limiter une fonctionnalité, suspendre ou bloquer un compte en cas d'abus, fraude, comportement suspect ou non-respect des règles. Les utilisateurs doivent rester vigilants avant toute rencontre, transaction, paiement ou partage d'informations personnelles."
      ]
    },
    "publishExtra": {
      "stepOf": "Étape {n} sur {total}",
      "stepsLabel": "Étapes du dépôt",
      "stepNext": "Continuer",
      "stepBack": "Retour",
      "stepChooseCat": "Choisissez une catégorie pour continuer.",
      "step1Title": "Que proposez-vous ?",
      "step1Sub": "La catégorie décide des champs et du nombre de photos.",
      "step2Title": "Vos photos",
      "step2Sub": "La première est la couverture · {min} au minimum · {max} au maximum.",
      "step3Title": "L'essentiel",
      "step3Sub": "Ce que l'acheteur lit en premier.",
      "step4Title": "Les détails",
      "step4Sub": "Les caractéristiques et votre description.",
      "edit": "Modifier l'annonce",
      "sellerDisplay": "Nom affiché sur l'annonce",
      "sellerDisplayHelp": "Visible uniquement sur l'annonce et dans la messagerie côté acheteur. Les messages arrivent toujours sur la messagerie admin.",
      "country": "Pays",
      "address": "Quartier / adresse approximative",
      "addressPh": "Ex. quartier, rue proche, résidence...",
      "activateBoost": "Activer Pulse",
      "boostLimit": "Pulse est limité à 3 activations par mois. Restant ce mois-ci",
      "discountPrice": "Prix remisé",
      "promoDuration": "Durée promotion",
      "customEnd": "Date de fin personnalisée",
      "availability": "Disponibilité",
      "availableToday": "Disponible aujourd'hui",
      "gearboxNone": "Non précisée",
      "energyClassNone": "Non précisée",
      "preview": "Aperçu",
      "previewTitle": "Aperçu acheteur",
      "previewFeed": "Dans le fil",
      "previewFeedNote": "Exactement la carte que verront les acheteurs.",
      "previewDetail": "Sur la fiche (résumé)",
      "photoCover": "Couverture",
      "photoMakeCover": "Faire de cette photo la couverture",
      "photoMoveLeft": "Avancer la photo",
      "photoMoveRight": "Reculer la photo",
      "photoRemove": "Retirer la photo",
      "draftResumed": "Brouillon repris — votre saisie a été conservée.",
      "draftRestart": "Recommencer à zéro",
      "draftRestartTitle": "Recommencer à zéro ?",
      "draftRestartMsg": "Le brouillon (photos et vidéo comprises) sera définitivement supprimé.",
      "customBrand": "Marque personnalisée",
      "brandName": "Nom de la marque",
      "customModel": "Modèle personnalisé",
      "modelName": "Nom du modèle",
      "category": "Catégorie",
      "subcategory": "Sous-catégorie",
      "photosAdd": "Ajouter des photos",
      "limitReached": "Limite atteinte",
      "photosRequired": "Minimum 2 photos originales obligatoires pour publier ou modifier une annonce.",
      "photoTip": "Ajoutez des photos originales prises par vous-même. Les images récupérées sur Internet ou les banques d'images peuvent bloquer l'annonce et l'envoyer en attente d'approbation.",
      "shortVideo": "Vidéo courte (optionnelle)",
      "videoCheck": "Contrôle de la vidéo…",
      "videoAdd": "Ajouter une vidéo courte",
      "videoHelp": "La vidéo est contrôlée avant publication. Aucune compression automatique n'est lancée, pour éviter de bloquer la preview.",
      "remove": "Retirer",
      "save": "Enregistrer les modifications ?",
      "durationToday": "Aujourd'hui seulement",
      "duration24h": "24 heures",
      "duration3d": "3 jours",
      "duration7d": "7 jours",
      "durationCustom": "Date de fin personnalisée",
      "sellerExample": "Ex. Marc Weber",
      "priceExample": "Ex. 250"
    },
    "reviewReminder": {
      "message": "Votre échange est terminé. Pensez à laisser un avis pour renforcer la confiance sur LANAC.",
      "action": "Laisser un avis",
      "title": "Pensez à laisser un avis",
      "notice": "Votre échange est terminé. Votre avis aide à renforcer la confiance sur LANAC."
    },
    "flow": {
      "confirmTransaction": "Je confirme la transaction",
      "confirmTransactionRdv": "Je confirme la transaction / le RDV",
      "sellerCancel": "Annulation vendeur",
      "clientNoShow": "No-show client",
      "versionsDifferent": "Versions différentes. L'échange est clôturé.",
      "dealConfirmReminder": "La confirmation de transaction est toujours en attente. Merci de confirmer la transaction ou de signaler un problème si nécessaire.",
      "transactionConfirmedReview": "Transaction confirmée par les deux parties. Vous pouvez maintenant laisser un avis.",
      "transactionAutoConfirmed": "Sans réponse sous 10 jours, la transaction a été confirmée automatiquement. Vous pouvez laisser un avis.",
      "visitConfirmedReview": "Visite confirmée par les deux parties. Vous pouvez maintenant laisser un avis.",
      "visitDoneConfirmed": "Rendez-vous honoré et confirmé.",
      "visitDoneConfirmedOwner": "Rendez-vous honoré et confirmé.",
      "postVisitDealQuestion": "La visite a eu lieu. Le bien vous intéresse-t-il toujours et la location / vente a-t-elle avancé ?",
      "problemResolvedRequest": "L'autre partie indique que le problème est résolu. Confirmez-vous ?",
      "problemResolvedYes": "Oui, le problème est résolu",
      "problemResolvedNo": "Non, je maintiens ma version",
      "problemResolvedStartWarning": "En poursuivant, vous confirmez que le problème a été résolu entre vous et l'autre partie. Cette action demandera une confirmation à l'autre partie avant de clôturer l'échange.",
      "problemResolvedConfirmWarning": "En poursuivant, vous confirmez que le problème est bien résolu. L'échange pourra ensuite être clôturé selon le résultat final confirmé par les deux parties.",
      "problemResolvedDisputeWarning": "En poursuivant, vous confirmez que le problème n'est pas résolu et que vous maintenez votre version. Vos versions diffèrent : l'échange sera clôturé sans transaction, et l'annonce redeviendra disponible si elle est encore réservée pour cet échange.",
      "finalResultQuestion": "Quel est le résultat final ?",
      "finalTransactionDone": "La transaction a finalement eu lieu",
      "finalTransactionNotDone": "La transaction n'a pas eu lieu / l'article est toujours disponible",
      "finalRdvDone": "L'essai a finalement eu lieu",
      "finalRdvNotDone": "L'essai n'a pas eu lieu",
      "finalVisitDone": "La visite a finalement eu lieu",
      "finalVisitNotDone": "La visite n'a pas eu lieu",
      "incidentFinalTransactionDoneWarning": "En poursuivant, vous confirmez que la transaction a finalement eu lieu. Cette confirmation pourra clôturer l'échange et rendre les avis disponibles si les deux parties confirment le même résultat.",
      "incidentFinalTransactionNotDoneWarning": "En poursuivant, vous confirmez que la transaction n'a pas eu lieu. L'échange pourra être clôturé si les deux parties confirment le même résultat. À la clôture, l'annonce redeviendra disponible si elle est encore réservée pour cet échange.",
      "incidentFinalVehicleRdvDoneWarning": "En poursuivant, vous confirmez que l'essai a finalement eu lieu. L'échange pourra être clôturé si les deux parties confirment le même résultat.",
      "incidentFinalVehicleRdvNotDoneWarning": "En poursuivant, vous confirmez que l'essai n'a pas eu lieu. Aucun avis lié à l'essai ne doit être débloqué, sauf règle existante contraire.",
      "incidentFinalVisitDoneWarning": "En poursuivant, vous confirmez que la visite a finalement eu lieu. L'échange pourra être clôturé et les avis liés à la visite pourront devenir disponibles si les deux parties confirment le même résultat.",
      "incidentFinalVisitNotDoneWarning": "En poursuivant, vous confirmez que la visite n'a pas eu lieu. Les avis liés à cette visite ne doivent pas être débloqués.",
      "waitingOtherFinal": "En attente de la confirmation de l'autre partie.",
      "incidentResolvedTransaction": "Problème résolu : transaction confirmée par les deux parties.",
      "incidentResolvedMeeting": "Problème résolu : le rendez-vous a bien eu lieu, confirmé par les deux parties.",
      "incidentResolvedNoTransaction": "Problème résolu : aucune transaction confirmée.",
      "incidentFinalDisagreement": "Vos versions diffèrent. L'échange est clôturé, sans transaction.",
      "exchangeClosedAfterTenDays": "10 jours se sont écoulés : cet échange est clôturé. Aucune autre action n'est nécessaire.",
      "autoCloseOn": "Cet échange se clôturera de lui-même le {date}, s'il n'est pas conclu d'ici là.",
      "autoCloseUntil": "jusqu'au {date}",
      "autoCloseToday": "Cet échange se clôturera de lui-même aujourd'hui, vers {date}, s'il n'est pas conclu d'ici là.",
      "autoCloseUntilToday": "jusqu'à {date}",
      "offerCycleCopy": "Demande de réservation envoyée · retrait proposé le {date}",
      "offerCycleRequest": "Réservation demandée · retrait le {date}",
      "offerCycleRequestPast": "Réservation demandée · la date de retrait proposée ({date}) est passée",
      "offerCycleNegotiation": "Créneau proposé · retrait le {date}",
      "offerCycleNegotiationPast": "Créneau proposé · la date proposée ({date}) est passée",
      "offerCycleConfirmed": "Réservation confirmée · retrait le {date}",
      "offerCyclePickup": "Retrait en cours — confirmez la transaction",
      "offerCycleOverdue": "Réservation confirmée · le délai de retrait est passé.",
      "offerCycleDeclared": "Transaction à confirmer",
      "offerCycleReported": "Réservation interrompue — la suite se règle dans cette conversation.",
      "offerCycleCancelledRequest": "Demande de réservation retirée.",
      "offerCycleCancelledReservation": "Réservation annulée.",
      "offerCycleCancelledSeller": "Réservation annulée par le vendeur.",
      "offerCycleEndedPickup": "Réservation expirée — le délai de retrait est passé.",
      "offerCycleEndedOther": "Réservée pour un autre acheteur.",
      "offerCycleEndedSold": "Demande de réservation close.",
      "offerCycleEndedDeclined": "Réservation refusée.",
      "offerCycleEndedNoSeller": "Demande de réservation expirée — sans réponse du vendeur.",
      "offerCycleEndedNoBuyer": "Négociation expirée — sans réponse de l'acheteur.",
      "offerCycleEndedExpired": "Demande de réservation expirée.",
      "offerCycleEnded": "Réservation terminée.",
      "offerCycleDealOn": "Transaction confirmée le {day}.",
      "offerCycleDeal": "Transaction confirmée.",
      "offerCycleClosedOn": "Échange clôturé le {day}, sans transaction.",
      "offerCycleClosed": "Échange clôturé, sans transaction.",
      "offerCycleUnansweredOn": "Échange clôturé le {day} — aucune réponse n'a été enregistrée.",
      "offerCycleUnanswered": "Échange clôturé — aucune réponse n'a été enregistrée.",
      "offerCycleNothingElse": "Aucune autre action n'est nécessaire.",
      "offerCycleRearmedSeller": "L'offre reste acceptée : l'acheteur peut proposer une nouvelle date de retrait.",
      "responseSaved": "Votre réponse est enregistrée.",
      "vehicleInterestQuestion": "Le véhicule vous intéresse encore ?",
      "vehicleInterestNotice": "Vous pouvez lancer une réservation depuis la conversation.",
      "postVisitReservationStarted": "Réservation lancée.",
      "postVisitNoReservation": "Aucune réservation lancée.",
      "sellerSuggestsAnotherSlot": "Le vendeur propose un autre créneau",
      "buyerSuggestsAnotherSlot": "L'acheteur propose un autre créneau",
      "checkCardOtherSlot": "consultez l'affiche pour confirmer ou proposer un autre créneau.",
      "defaultReserveNote": "Je souhaite réserver cette annonce.",
      "listingReserved": "Annonce réservée",
      "reservationAcceptedLower": "réservation acceptée",
      "reservationExpires1h": "Votre réservation expire dans 1 heure",
      "pickupPlanned": "Retrait prévu",
      "reservationExpiresSoon": "Votre réservation expire bientôt",
      "confirmSaleOrExtend": "Confirmer la vente ou reporter le retrait ?",
      "reservationExpires5m": "Votre réservation expire dans 5 minutes",
      "requested": "Demandée",
      "toConfirm": "À confirmer",
      "locked": "Verrouillé",
      "confirmedShort": "Confirmé",
      "versionsDifferentShort": "Versions différentes",
      "iConfirm": "Je confirme",
      "iDoNotConfirm": "Je ne confirme pas",
      "meetingPlaceNeeded": "Lieu de rencontre à définir",
      "meetingPlaceShared": "Lieu de rencontre partagé",
      "meetingPlaceLater": "Lieu de rencontre à venir",
      "meetingPlaceLaterFull": "Lieu de rencontre : l'adresse sera partagée plus tard dans la conversation.",
      "meetingPlaceNoBasis": "Le lieu se partage pour une réservation ou une visite acceptée : cet échange n'en a plus.",
      "meetingAddressInvalid": "Adresse non valable : de 3 à 200 caractères, sans lien ni site web.",
      "meetingPlaceSellerOnly": "Seul le vendeur partage le lieu de rendez-vous.",
      "shareAddressOrLater": "partagez l'adresse ou indiquez que vous la donnerez plus tard.",
      "sellerWillShareAddress": "L'adresse sera partagée dans la conversation.",
      "agreementConfirmedClose": "Accord confirmé. Vous pouvez clôturer l'accord, ou signaler un no-show ou une annulation.",
      "reserveRequest": "Demande de réservation",
      "agreedPrice": "Prix convenu",
      "requestedDuration": "Durée demandée",
      "acceptedDuration": "Durée acceptée",
      "proposedDuration": "Durée proposée",
      "pickup": "Retrait",
      "address": "Adresse",
      "proposedSlot": "Créneau proposé",
      "buyerNewProposal": "Nouvelle proposition acheteur",
      "sellerNewProposalUpdate": "Le vendeur propose une autre date de retrait",
      "buyerNewProposalUpdate": "L'acheteur propose une autre date de retrait",
      "youNewProposalUpdate": "Vous proposez une autre date de retrait",
      "reservationUpdateTitle": "Mise à jour de la réservation",
      "countdown": "Compte à rebours",
      "reservationDurationEnded": "La réservation est arrivée à échéance. Merci de mettre à jour le statut de l'annonce et de confirmer si l'article est bien vendu / acheté.",
      "originalMessageReservationBlocks": "Le message original reste dans la conversation. Les nouvelles demandes restent possibles tant qu'aucune réservation n'est acceptée, puis sont bloquées dès qu'une réservation est confirmée.",
      "reservationUnavailableAfterAccepted": "Cette demande est fermée : une autre réservation a déjà été acceptée.",
      "reservationNoLongerAvailable": "Cette annonce n'est plus disponible pour une nouvelle réservation.",
      "reservationExpired": "La réservation a expiré",
      "listingAvailableAgain": "L'annonce est de nouveau disponible",
      "notifyIfAvailableAgain": "Vous serez notifié(e) si l'annonce redevient disponible",
      "listingStillAvailable": "L'annonce reste disponible",
      "offerRetryYou": "Vous pouvez en faire une nouvelle",
      "offerRetryBuyer": "L'acheteur peut en faire une nouvelle",
      "requestRetryYou": "Vous pouvez en envoyer une nouvelle quand vous le souhaitez",
      "itemAvailableAgain": "L'article est à nouveau disponible",
      "reservationExpiredCombined": "La réservation a expiré. L'annonce est de nouveau disponible.\nLa réservation a expiré. L'article est à nouveau disponible.",
      "dealConfirmIntro": "Confirmez uniquement si la transaction ou le rendez-vous a réellement eu lieu avec cette personne. Après confirmation par les deux parties, les avis vérifiés seront disponibles.",
      "compactRdvPending": "Essai en attente",
      "compactReservationPending": "Réservation en attente",
      "compactVisitPending": "Visite en attente",
      "compactRdvAccepted": "Essai accepté",
      "compactReservationConfirmed": "Réservation confirmée",
      "compactVisitConfirmed": "Visite confirmée",
      "compactView": "Voir",
      "compactPending": "En attente",
      "compactConfirmed": "Confirmé",
      "compactSlotProposed": "créneau proposé",
      "compactSlotsProposed": "créneaux proposés",
      "compactExtensionRequest": "report du retrait",
      "compactSlotChange": "changement de créneau",
      "compactOtherSlotProposed": "autre créneau proposé",
      "compactStatusUpdated": "statut mis à jour",
      "confirmDealWarning": "Vous allez confirmer définitivement cette transaction. Cette action est irréversible. Continuer ?",
      "leaveReviewNow": "Laissez un avis.",
      "noshowNotYet": "Une absence se signale à partir de l'heure du rendez-vous.",
      "incidentSourceClosed": "Cet échange est déjà clos : il ne peut plus faire l'objet d'un signalement.",
      "engagementClosed": "Cet échange est déjà clos.",
      "engagementDisputed": "Un signalement est en cours sur cet échange.",
      "counterpartyDeleted": "L'autre membre a supprimé son compte : cet échange ne peut plus avancer."
    },
    "profile": {
      "menu": {
        "profileAccount": "Profil & compte",
        "myListings": "Mes annonces",
        "notifications": "Notifications",
        "adminPanel": "Panel admin",
        "cookies": "Cookies",
        "about": "À propos de nous",
        "legal": "Informations légales",
        "platform": "Notre plateforme",
        "contact": "Nous contacter",
        "logout": "Déconnexion",
        "deleteAccount": "Supprimer le compte"
      },
      "trustScore": "Votre score de confiance est de {score}/100",
      "verified": "Compte vérifié",
      "emailToValidate": "Email à valider",
      "adminCheck": "Contrôle admin",
      "listings": "Annonces",
      "followers": "Abonnés",
      "following": "Abonnements",
      "myProfile": "Mon profil",
      "profilePhoto": "Photo de profil",
      "changePhoto": "Changer la photo",
      "delete": "Supprimer",
      "fullName": "NOM COMPLET",
      "country": "PAYS",
      "city": "VILLE",
      "phoneOptional": "TÉLÉPHONE OPTIONNEL",
      "phoneHelp": "Utilisé uniquement comme information de contact si vous le souhaitez.",
      "email": "EMAIL",
      "emailVerified": "Email validé",
      "save": "Enregistrer",
      "appLanguage": "Langue de l'application",
      "appLanguageHelp": "Vous pouvez la modifier ici après connexion.",
      "myAccount": "Mon compte",
      "verificationStatus": "Statut de vérification",
      "unverified": "Compte non vérifié",
      "phoneOptionalShort": "Téléphone optionnel",
      "verificationHelp": "La vérification téléphone reste optionnelle au lancement. Elle pourra devenir demandée plus tard pour les annonces de forte valeur, l'activité suspecte, les annulations répétées, trop de messages rapides ou trop d'annonces publiées d'un coup.",
      "emailValidation": "Validation email",
      "emailValidationHelp": "Entrez l'email à valider. LANAC envoie un code de validation.",
      "emailToValidateLabel": "EMAIL À VALIDER",
      "sendEmailLink": "Envoyer le code par email",
      "emailReceived": "Email reçu",
      "from": "De",
      "linkSent": "Code envoyé à {email}.",
      "openValidationLink": "Ouvrir le lien de validation",
      "receivedCode": "Code reçu",
      "validate": "Valider",
      "phoneValidation": "Validation téléphone",
      "phoneValidationHelp": "Entrez ou modifiez le numéro. LANAC envoie ensuite un code par SMS.",
      "numberToValidate": "NUMÉRO À VALIDER",
      "sendSms": "Envoyer le code SMS",
      "smsReceived": "SMS reçu",
      "sender": "Expéditeur",
      "smsSent": "Code envoyé au {phone} : {code}",
      "changePassword": "Changer le mot de passe",
      "oldPassword": "ANCIEN MOT DE PASSE",
      "newPassword": "NOUVEAU MOT DE PASSE",
      "minChars": "8 caractères minimum",
      "publish": "+ Publier",
      "noListings": "Vous n'avez pas encore publié d'annonce.",
      "createFirst": "Créer ma première annonce",
      "available": "Disponibles",
      "pending": "En attente",
      "total": "Total",
      "closedListing": "Annonce clôturée : modification et Pulse désactivés.",
      "internalStatus": "Statut géré par l'administration.",
      "notificationPush": "Notifications Push",
      "notificationPushHelp": "Recevez des alertes en temps réel sur vos appareils.",
      "notificationEmail": "Notifications Email",
      "notificationEmailHelp": "Recevez des récapitulatifs et alertes par email.",
      "notificationInApp": "Notifications dans l'app",
      "notificationInAppHelp": "Affichez les notifications dans la cloche. Désactivé, elles sont masquées mais conservées.",
      "cookieSettings": "Paramètres des cookies",
      "cookieOptions": [
        [
          "essential",
          "Essentiels uniquement",
          "Nécessaires au fonctionnement du site.",
          "var(--color-success)"
        ],
        [
          "analytics",
          "Essentiels + Analytiques",
          "Nous aide à améliorer l'expérience utilisateur.",
          "var(--color-info)"
        ],
        [
          "all",
          "Tous les cookies",
          "Inclut les cookies marketing et publicitaires.",
          "var(--color-primary)"
        ]
      ],
      "aboutTitle": "À propos de LANAC",
      "aboutP1": "LANAC est une plateforme locale de petites annonces dédiée au Luxembourg et à la Grande Région. Notre mission est de faciliter les échanges entre particuliers, professionnels et artisans dans l'immobilier, l'automobile, les services et les objets du quotidien.",
      "aboutP2": "LANAC privilégie la confiance : validation email, validation téléphone, messagerie intégrée, signalements, avis utilisateurs et analyse anti-fraude des annonces. L'objectif est de réduire les arnaques, les spams et les annonces trompeuses tout en gardant une expérience simple pour les utilisateurs sérieux.",
      "version": "Version",
      "versionText": "LANAC v2.0 · Grande Région Edition",
      "rights": "© 2026 Velyra Technologies S.à r.l. Tous droits réservés.",
      "legalTitle": "Informations légales",
      "legalCards": [
        [
          "Éditeur de l'application",
          "Lanac est éditée et exploitée par Velyra Technologies S.à r.l., 30 Am Aker, Lamadelaine, Luxembourg."
        ],
        [
          "Conditions Générales d'Utilisation",
          "En utilisant Lanac, l'utilisateur accepte de publier uniquement des informations exactes, licites et vérifiables. Les annonces frauduleuses, trompeuses, discriminatoires, illégales, contrefaites, spam ou contenant des liens externes suspects peuvent être bloquées, masquées, mises en attente ou supprimées."
        ],
        [
          "Politique de confidentialité",
          "Le responsable de traitement est Velyra Technologies S.à r.l., 30 Am Aker, Lamadelaine, Luxembourg. Les données sont traitées conformément au RGPD et ne sont jamais vendues à des tiers."
        ],
        [
          "Responsabilité individuelle des utilisateurs",
          "Chaque utilisateur est personnellement et légalement responsable des annonces, descriptions, images, vidéos, messages, prix, coordonnées et autres contenus qu'il publie ou échange via Lanac. Il doit respecter les lois applicables, disposer des droits nécessaires sur ses contenus et éviter tout contenu frauduleux, trompeur, illégal, volé, usurpé, interdit, harcelant ou abusif. Lanac reste une plateforme intermédiaire de mise en relation : les transactions, rendez-vous, visites, paiements, échanges et accords relèvent des utilisateurs concernés. Lanac peut retirer un contenu, limiter une fonctionnalité, suspendre ou bloquer un compte en cas d'abus, fraude, comportement suspect ou non-respect des règles. Restez vigilant avant toute rencontre, transaction, paiement ou partage d'informations personnelles."
        ],
        [
          "Publication, vérification et modération",
          "Lanac peut demander une validation par email et/ou téléphone avant de rendre certaines annonces visibles. Les photos doivent être originales, prises par l'utilisateur ou utilisées avec autorisation."
        ],
        [
          "Transactions et sécurité des échanges",
          "Lanac met en relation les utilisateurs mais ne devient pas partie au contrat. Pour votre sécurité, gardez les échanges dans la messagerie Lanac et signalez toute demande inhabituelle."
        ],
        [
          "Avis vérifiés et confirmation de transaction",
          "Un avis ne peut être publié qu'après confirmation de transaction ou de visite par les deux parties."
        ],
        [
          "Politique des cookies",
          "Lanac utilise des cookies essentiels au fonctionnement du service, à la sécurité de session et aux préférences utilisateur."
        ]
      ],
      "platformTitle": "Notre plateforme",
      "platformCards": [
        [
          "Immobilier",
          "Achat, vente et location de biens immobiliers dans toute la Grande Région."
        ],
        [
          "Automobiles",
          "Véhicules d'occasion et neufs avec filtres avancés."
        ],
        [
          "Services & Travaux",
          "Artisans, professionnels du bâtiment, jardinage et services locaux."
        ],
        [
          "Autres annonces",
          "Électronique, ameublement, vêtements, loisirs — près de chez vous."
        ],
        [
          "Messagerie et confiance",
          "Messagerie intégrée, score de confiance, favoris et échanges plus sûrs entre utilisateurs."
        ],
        [
          "Réservations et offres",
          "Demandes de réservation, RDV, visites et offres de prix restent simples et centralisées."
        ]
      ],
      "contactTitle": "Nous contacter",
      "contactHelp": "Un problème, une question ou une suggestion ? L'administration recevra votre message directement.",
      "yourMessage": "VOTRE MESSAGE",
      "messagePlaceholder": "Décrivez votre demande...",
      "sendAdmin": "Envoyer à l'administration",
      "deleteTitle": "Supprimer mon compte",
      "deleteWarning": "Attention — action irréversible",
      "deleteText": "La suppression de votre compte entraîne :\n• La perte de toutes vos annonces publiées\n• La perte de vos conversations\n• La suppression définitive de votre profil\nCette action ne peut pas être annulée.",
      "deleteForever": "Supprimer définitivement mon compte",
      "engaged": {
        "checking": "Vérification de vos échanges en cours…",
        "title": "Des échanges sont encore en cours",
        "intro": "Votre compte pourra être supprimé dès qu'ils seront terminés, pour que chacun puisse aller au bout de ce qui a été engagé.",
        "until": "Sans nouvelle étape, la suppression sera possible au plus tard le {date}.",
        "threadsTitle": "Échanges concernés",
        "threadUntil": "Au plus tard le {date}",
        "threadFallback": "Échange",
        "openThread": "Ouvrir l'échange : {title}",
        "error": "Impossible de vérifier vos échanges pour le moment.",
        "retry": "Réessayer",
        "free": "Aucun échange en cours : votre compte peut être supprimé."
      },
      "notices": {
        "nameRequired": "Le prénom/nom est requis.",
        "invalidEmail": "Email invalide.",
        "emailUsed": "Cet email est déjà utilisé.",
        "profileUpdated": "✓ Profil mis à jour.",
        "profileUpdatedVerify": "✓ Profil mis à jour. Validez vos nouvelles coordonnées dans Profil & compte.",
        "emailSent": "Email de validation envoyé par LANAC à {email}.",
        "askEmail": "Demandez d'abord un code de validation.",
        "badEmailCode": "Code email incorrect.",
        "emailOk": "✓ Email validé.",
        "phoneRequired": "Renseignez d'abord un numéro de téléphone.",
        "badPhone": "Numéro de téléphone invalide.",
        "smsSent": "SMS envoyé par LANAC au {phone}.",
        "askSms": "Demandez d'abord un code SMS.",
        "badSms": "Code SMS incorrect.",
        "phoneOk": "✓ Téléphone validé.",
        "fillBoth": "Remplissez les deux champs.",
        "oldPwdBad": "Ancien mot de passe incorrect.",
        "pwdMin": "Minimum 8 caractères.",
        "pwdDifferent": "Le nouveau mot de passe doit être différent de l'ancien.",
        "pwdOk": "✓ Mot de passe modifié.",
        "prefsOk": "✓ Préférences enregistrées.",
        "cookiesOk": "✓ Paramètres cookies enregistrés.",
        "messageRequired": "Saisissez votre message.",
        "messageSent": "✓ Message envoyé à l'administration.",
        "deleteConfirm": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
        "logoutConfirm": "Se déconnecter de LANAC sur cet appareil ?"
      },
      "brandLine": "Lanac, a product of Velyra Technologies."
    },
    "filterUi": {
      "close": "Fermer",
      "filters": "Filtres",
      "allCats": "Toutes catégories",
      "results": "résultat(s)",
      "all": "Tous",
      "allF": "Toutes",
      "allCountries": "Tous pays",
      "buy": "Achat",
      "rent": "Location",
      "adType": "Type d'annonce",
      "location": "Pays et lieu",
      "property": "Type de bien",
      "rooms": "Nombre de pièces",
      "more": "Autres filtres",
      "brand": "Marque",
      "fuel": "Carburant",
      "service": "Type de service",
      "category": "Catégorie",
      "priceMax": "Prix maximum",
      "near": "Près de chez vous",
      "showResults": "Afficher les résultats",
      "clear": "Effacer",
      "exactCity": "Ville exacte",
      "choose": "Choisir",
      "offer": "Faire une offre",
      "reserve": "Réserver",
      "visit": "Demander une visite",
      "quote": "Demander un devis",
      "message": "Message",
      "description": "Description",
      "details": "Détails",
      "sellerProfile": "Voir le profil & avis",
      "interesting": "Annonces intéressantes",
      "share": "Partager",
      "report": "Signaler",
      "favoriteAdd": "Ajouter aux favoris",
      "favoriteRemove": "Retirer des favoris",
      "chatSafety": "Pour votre sécurité, ne partagez aucune donnée personnelle, ne cliquez pas sur des liens externes et ne scannez pas de QR codes."
    },
    "tax": {
      "impossible-de-charger-l_3e3e68": "Impossible de charger l'annonce complète. Vérifiez votre connexion et réessayez.",
      "trier_6ef1f1": "Trier",
      "pertinence_80bf0f": "Pertinence",
      "plus-recent_d51066": "Plus récent",
      "prix_08cfea": "Prix ↑",
      "prix-croissant_f7f1e9": "Prix croissant",
      "7-derniers-jours_7dc85e": "7 derniers jours",
      "a-active-sa-p-en-attente_99436d": "{a} active{sa} · {p} en attente",
      "a-activer-pour-recevoir_49e79c": "À activer pour recevoir les messages app fermée.",
      "a-propos_d75d7b": "À propos",
      "a-proximite_de994a": "à proximité",
      "a-revoir_9b3468": "À revoir",
      "a-valider_fa0c06": "à valider",
      "a-verifier_31b380": "À vérifier",
      "abonne_0db656": "✓ Abonné",
      "abonnements_9982de": "Abonnements",
      "abonnes_fea545": "Abonnés",
      "acces-refuse-ville-utili_faeddc": "Accès refusé — ville utilisée",
      "achat_ab4f89": "achat",
      "actif-les-publications-c_0ec450": "Actif : les publications consécutives passent en validation selon la règle actuelle.",
      "actif_9ba8a9": "ACTIF",
      "actif_d60405": "Actif",
      "action-deja-traitee_f07104": "Action déjà traitée.",
      "action-non-autorisee_500883": "Action non autorisée.",
      "active-ou-desactive-l-en_e1e552": "Active ou désactive l'envoi de tous les emails automatiques (annonces, réservations, transactions, comptes, messages non lus…). N'affecte pas les emails de validation ni les notifications dans l'app.",
      "activer-le-son_1fe2d8": "Activer le son",
      "activer-le-son_618c06": "Activer le son",
      "activer_32e071": "Activer",
      "actives-vous-recevrez-le_0d15bb": "Actives — vous recevrez les messages même app fermée.",
      "actives_868ea3": "Activés",
      "activez-votre-position-p_4ae0b4": "Activez votre position pour voir en priorité les annonces proches de vous.",
      "adresse-approx_52f7e2": "Adresse approx.",
      "adresse-partagee-dans-la_a61158": "adresse partagée dans la conversation",
      "adresse-partagee-dans-la_dce4c5": "Adresse partagée dans la conversation ✓",
      "afficher-le-media-en-ple_5d22ad": "Afficher le média en plein écran",
      "afficher-le-mot-de-passe_016d6c": "Afficher le mot de passe",
      "aide-informations_111c94": "Aide & informations",
      "ajoute-aux-favoris_8e8d6a": "Ajouté aux favoris.",
      "ajouter-aux-favoris_0ce728": "Ajouter aux favoris",
      "alerte-active_d12e98": "Alerte active",
      "alerte-creee_f56c93": "Alerte créée.",
      "alerte-plafond_2c91af": "Vous avez atteint le maximum d'alertes. Supprimez-en une pour en créer une autre.",
      "alerte-remplacer-titre_7d4e18": "Vos alertes sont au complet",
      "alerte-remplacer-question_b83f05": "Remplacer la plus ancienne — « {label} » ?",
      "alerte-remplacer-bouton_4a1c62": "Remplacer",
      "alerte-non-creee_9e2d37": "L'alerte n'a pas pu être créée.",
      "alerte-remplacee_16b8c4": "Alerte remplacée.",
      "cette-alerte-est-trop-lo_afe5d4": "Cette alerte est trop longue pour être enregistrée : raccourcissez votre recherche.",
      "alerte-disponibilite_b55ff7": "Alerte disponibilité",
      "annee-du-vehicule-incohe_41f28b": "Année du véhicule incohérente",
      "annonce-admin-mise-en-at_a05c9b": "Annonce admin mise en attente : produit ou signal interdit détecté",
      "annonce-approuvee-malgre_d4217a": "✓ Annonce approuvée malgré le refus automatique",
      "annonce-approuvee_2be92a": "Annonce approuvée",
      "annonce-cloturee-le-stat_4e5d37": "Annonce clôturée : le statut ne peut plus être modifié.",
      "annonce-cloturee-modific_3a30f5": "Annonce clôturée : modification et Pulse désactivés.",
      "annonce-en-attente-d-app_2f5695": "Annonce en attente d'approbation",
      "annonce-en-attente-valid_ffdf66": "Annonce en attente - validez votre email pour accélérer l'approbation",
      "annonce-en-cours-de-char_fbf532": "Annonce en cours de chargement, réessayez.",
      "annonce-introuvable-rouv_66d01d": "Annonce introuvable — rouvrez l'annonce puis réessayez.",
      "annonce-introuvable_6b276d": "Annonce introuvable.",
      "annonce-modifiee-avec-su_7c03c5": "Annonce modifiée avec succès.",
      "annonce-modifiee-et-appr_4623fc": "✓ Annonce modifiée et approuvée.",
      "annonce-modifiee_e64a01": "Annonce modifiée",
      "annonce-publiee-automati_416220": "✓ Annonce publiée automatiquement !",
      "annonce-publiee_5d2c62": "Annonce publiée",
      "annonce-publiee_e8f2fa": "✓ Annonce publiée !",
      "annonce-refusee_7afb48": "Annonce refusée",
      "annonce-remise-disponibl_14d921": "Annonce remise disponible. Confirmation demandée à l'autre partie.",
      "annonce-s_8e2e26": "annonce(s)",
      "annonce-supprimee_5c39e3": "Annonce supprimée",
      "annonce-suspecte_232d0f": "Annonce suspecte",
      "annonce_46cd6b": "Annonce",
      "annonces-actives_d49b98": "Annonces actives",
      "annonces-ajoutees_d3ec45": "Annonces ajoutées",
      "annonces-cloturees_a4b027": "Annonces clôturées",
      "annonces-favoris_69e90a": "Annonces & favoris",
      "annonces-pres-de-chez-vo_258738": "Annonces près de chez vous",
      "annonces_addd75": "Annonces",
      "annulation-de-la-vente-d_46fa54": "Annulation de la vente / du rendez-vous signalée.",
      "annulation-essai-vendeur_3bcae9": "Annulation essai vendeur signalée",
      "annulation-essai-vendeur_5b2eb1": "Annulation essai vendeur",
      "annulation-proprietaire_779d3e": "Annulation propriétaire",
      "annulation-proprietaire_e16639": "annulation propriétaire signalée",
      "annulation-vendeur-signa_38e215": "Annulation vendeur signalée",
      "annulation-vendeur-signa_856b44": "annulation vendeur signalée",
      "annulation-vendeur_8a60bf": "Annulation vendeur",
      "annulation-visite-propri_61c2a3": "Annulation visite propriétaire signalée",
      "annulation-visite-propri_cff02a": "Annulation visite propriétaire",
      "annulation-visite-vendeu_3c1ed0": "Annulation visite vendeur signalée",
      "annulation-visite-vendeu_adfc03": "Annulation visite vendeur",
      "annulations_613c1a": "Annulations",
      "annuler_4fa675": "Annuler",
      "annuler_64544e": "Annuler",
      "apercu-public_6a44dc": "Aperçu public",
      "apparence_e01151": "Apparence",
      "arreter-pulse_bdf904": "Arrêter Pulse",
      "article-disponible-a-nou_2f5bbf": "Article disponible à nouveau",
      "article-ne-convient-pas_05c2d0": "Article ne convient pas - versions différentes",
      "article-ne-convient-pas_525f0f": "Article ne convient pas",
      "article-reserve-retrait_9031c6": "article réservé · retrait le",
      "aucune-annonce-publiee_e18c07": "Aucune annonce publiée.",
      "aucune-transaction-confi_269e3c": "Aucune transaction confirmée après cette visite.",
      "aucune-transaction-confi_81af6f": "Aucune transaction confirmée après la visite.",
      "aujourd-hui_36e340": "aujourd'hui",
      "aujourd-hui_79fc69": "Aujourd'hui",
      "automatique-suit-le-regl_a35b39": "« Automatique » suit le réglage de votre appareil.",
      "automatique_475d31": "Automatique",
      "autour-de-moi_14ccbf": "Autour de moi",
      "autre_ded062": "Autre",
      "avis-publie_a4e964": "✓ Avis publié",
      "avis-verifie-transaction_e2a2da": "Avis vérifié — transaction confirmée",
      "avis_227065": "Avis +",
      "avis_2ccdf8": "Avis",
      "avis_3d9300": "Avis -",
      "banniere-message-entrant_dc3907": "Bannière message entrant",
      "bien-immobilier-disponib_24ae53": "Bien immobilier disponible à nouveau",
      "bien-immobilier-ne-convi_3d0896": "Bien immobilier ne convient pas",
      "bien-immobilier-ne-convi_93b1f6": "Bien immobilier ne convient pas - versions différentes",
      "bloque_431013": "BLOQUÉ",
      "bloquees-dans-les-reglag_c015c9": "Bloquées dans les réglages du navigateur de cet appareil.",
      "bloquer_560468": "Bloquer",
      "pulse-gratuit_30705f": "Pulse : Gratuit",
      "pulse-plus_87e91d": "Pulse : Plus",
      "pulse-premium_22119c": "Pulse : Premium",
      "pulse-active_96ef22": "✓ Pulse activé.",
      "pulse-active_d63fb4": "Pulse activé",
      "pulse-arrete_39acf4": "Pulse arrêté",
      "pulse-arrete_951184": "Pulse arrêté.",
      "pulse_48cf18": "Pulse",
      "cartons_0ab58c": "Cartons",
      "caution-anormalement-ele_98655d": "Caution anormalement élevée par rapport au loyer",
      "ce-creneau-de-retrait-n_32bc6f": "Ce créneau de retrait n'est plus valide.",
      "ce-signalement-peut-impa_a76c5c": "Ce signalement peut impacter le score de confiance.",
      "ce-soir_c5d900": "Ce soir",
      "ce-statut-est-gere-par-l_fa50a6": "Ce statut est géré par l'administration.",
      "ce-vendeur-est-bloque-pa_141806": "Ce vendeur est bloqué par l'administration.",
      "cet-echange-est-bloque-u_1dc6fd": "Cet échange est bloqué : une nouvelle demande n'est pas possible. Ce qui est déjà engagé continue.",
      "vous-avez-bloque-cet-ech_9cfd22": "Vous avez bloqué cet échange : débloquez-le pour envoyer une nouvelle demande. Ce qui est déjà engagé continue.",
      "cet-email-est-deja-utili_eb9a12": "Cet email est déjà utilisé.",
      "cette-action-ne-peut-plu_3e698a": "Cette action ne peut plus être modifiée.",
      "cette-annonce-n-est-pas_234819": "Cette annonce n'est pas visible publiquement.",
      "cette-annonce-n-est-pas_4ef4b2": "Cette annonce n'est pas disponible pour une réservation.",
      "cette-annonce-n-est-plus_1083cd": "Cette annonce n'est plus disponible.",
      "votre-demande-a-ete-acce_4c3563": "Votre demande a été acceptée entre-temps : la réservation est active.",
      "cette-demande-est-deja-c_25819f": "Cette demande est déjà close.",
      "aucune-demande-en-attent_a6d2b4": "Aucune demande en attente à retirer sur cette annonce.",
      "tout-effacer_3f347d": "Tout effacer",
      "tout-effacer-historique_62ed24": "Tout effacer – historique de recherche",
      "historique-de-recherche_1bb631": "Historique de recherche effacé",
      "l-historique-n-a-pas-pu_911394": "L'historique n'a pas pu être effacé. Réessayez.",
      "le-retrait-est-deja-conf_5db9af": "Le retrait est déjà confirmé : la réservation ne peut plus être annulée.",
      "cette-annonce-n-est-plus_cce66e": "Cette annonce n'est plus visible.",
      "cette-reservation-n-est_58e27b": "Cette réservation n'est plus active pour votre compte.",
      "cette-reservation-n-est_cbb445": "Cette réservation n'est plus active.",
      "chez-vous_79cdff": "chez vous",
      "choisissez-les-canaux-po_afd167": "Choisissez les canaux pour chaque type. Les notifications essentielles (messages, transactions) restent toujours actives.",
      "choisissez-un-nouveau-mo_ff3ee7": "Choisissez un nouveau mot de passe pour terminer la réinitialisation.",
      "choisissez-une-date-de-r_407e2e": "Choisissez une date de retrait future pour lancer la réservation.",
      "choisissez-une-nouvelle_221ed4": "Choisissez une nouvelle date de retrait future.",
      "clair_eb1bc4": "Clair",
      "code-expire-renvoyez-un_1de8ee": "Code expiré. Renvoyez un nouveau code.",
      "code-incorrect-reessayez_175e69": "Code incorrect. Réessayez.",
      "code-sms_9ad3b5": "Code SMS",
      "compte-preferences_9561d2": "Compte & préférences",
      "compte-utilisateur_a2a471": "Compte utilisateur",
      "compte-verifie_59cbe5": "Compte vérifié",
      "compteur-local-prototype_7d68a1": "Compteur local prototype",
      "confiance-scores-regles_fdaa66": "Confiance — scores & règles",
      "confirmation-deja-envoye_e0f3a1": "Confirmation déjà envoyée à cette personne.",
      "confirmation-demandee-a_95cb5f": "confirmation demandée à l'autre partie.",
      "confirmation-envoyee-a-l_9854dc": "Confirmation envoyée à l'autre partie.",
      "confirme-impacte-le-trus_167c08": "Confirmé · impacte le trust",
      "confirmer-ce-signalement_445391": "Confirmer ce signalement ? Le score de confiance de l'utilisateur signalé baissera.",
      "confirmer-definitivement_24ee29": "Confirmer définitivement la transaction après visite ? Ce choix est irréversible.",
      "confirmer-definitivement_c570b7": "Confirmer définitivement ce statut après visite ?",
      "confirmer-le-mot-de-pass_3b8f85": "Confirmer le mot de passe",
      "confirmer-location-retra_ae025a": "Confirmer location / retrait",
      "confirmer-qu-aucune-loca_3d2436": "Confirmer qu'aucune location / vente n'a été conclue après cette visite ?",
      "confirmer_7ce0c0": "Confirmer",
      "confirmez-le-statut-prop_bac1dd": "confirmez le statut proposé.",
      "confirmez-votre-email-po_06c179": "Confirmez votre email pour publier une annonce.",
      "confirmez-votre-email-po_0be61c": "Confirmez votre email pour réserver.",
      "confirmez-votre-email-po_193a19": "Confirmez votre email pour activer votre compte et publier des annonces.",
      "confirmez-votre-email-po_23216d": "Confirmez votre email pour effectuer cette action.",
      "confirmez-votre-email-po_3f6aec": "Confirmez votre email pour faire une offre.",
      "confirmez-votre-email-po_76274f": "Confirmez votre email pour contacter ce vendeur.",
      "confirmez-votre-email-po_8e3f50": "Confirmez votre email pour demander un devis.",
      "confirmez-votre-email-po_ff05bd": "Confirmez votre email pour demander une visite.",
      "confirmez-votre-email_3dcac0": "Confirmez votre email",
      "connectez-vous-pour-aime_ed129f": "Connectez-vous pour aimer une annonce.",
      "connectez-vous-pour-envo_a3aafc": "Connectez-vous pour envoyer un message.",
      "connectez-vous-pour-publ_238767": "Connectez-vous pour publier une annonce.",
      "connectez-vous-pour-rece_043891": "Connectez-vous pour recevoir une notification.",
      "connectez-vous-pour-suiv_e516a3": "Connectez-vous pour suivre un utilisateur.",
      "connexion-oauth-indispon_172ebd": "Connexion OAuth indisponible. Veuillez contacter l'assistance.",
      "connexion-reussie-mais-l_338a9e": "Connexion réussie, mais le profil LANAC n'a pas pu être restauré.",
      "connexion-reussie-mais-l_5a2c51": "Connexion réussie, mais le profil LANAC n'a pas pu être créé. Réessayez ou contactez l'assistance.",
      "connexion_b4777b": "Connexion...",
      "consultee-recemment_b5709a": "Consultée récemment",
      "contenu-inapproprie_105aee": "Contenu inapproprié",
      "controle-admin_a36e01": "Contrôle admin",
      "controle-du-rythme-de-pu_253d08": "Contrôle du rythme de publication activé.",
      "controle-du-rythme-de-pu_4a968d": "Contrôle du rythme de publication désactivé pour tous.",
      "controle-du-rythme-de-pu_ab1379": "Contrôle du rythme de publication",
      "controle-manuel-du-profi_bf9459": "Contrôle manuel du profil. La validation téléphone reste optionnelle.",
      "controle-media-apres-mod_f25582": "Contrôle média après modification : annonce en validation admin.",
      "controle-media-apres-pub_f402d8": "Contrôle média après publication : annonce envoyée en validation admin.",
      "controle-media-deux-phot_7ae3f0": "Contrôle média : deux photos originales uploadées restent obligatoires après publication.",
      "controle-media-media-dej_0cb217": "Contrôle média : média déjà utilisé sur une autre annonce.",
      "controle-media-nom-de-fi_8a0c5e": "Contrôle média : nom de fichier compatible avec une capture / image téléchargée, validation admin requise.",
      "controle-media-photo-ext_db78ae": "Contrôle média : photo externe détectée après publication.",
      "controle-media-video-ext_2347d9": "Contrôle média : vidéo externe détectée après publication.",
      "controle-profil-retire_68ae8c": "Contrôle profil retiré.",
      "controle-profil-retire_faeef7": "Contrôle profil retiré",
      "controle-rythme-publicat_0591c0": "Contrôle rythme publication réactivé.",
      "controle-rythme-publicat_7cb4f7": "Contrôle rythme publication débloqué pour ce compte.",
      "controler-profil_30e6ac": "Contrôler profil",
      "conversation-demarree_aeb5bc": "Conversation démarrée !",
      "conversation-introuvable_43b81c": "Conversation introuvable pour cette réservation.",
      "coordonnees-de-contact-d_d75986": "Coordonnées de contact dans la description (contournement de la messagerie)",
      "couper-le-son_03b404": "Couper le son",
      "couper-le-son_382a23": "Couper le son",
      "creation_0bf11f": "Création...",
      "de-l-article_b0e82a": "de l'article",
      "debloquer-rythme_869de5": "Débloquer rythme",
      "debloquer_adee38": "Débloquer",
      "decouvrez-mon-profil-sur_48b280": "Découvrez mon profil sur Lanac.",
      "definir-un-nouveau-mot-d_498189": "Définir un nouveau mot de passe",
      "demain_83d802": "Demain",
      "demande-d-essai-envoyee_f9343a": "Demande d'essai envoyée ✓",
      "demande-d-essai-pour_609971": "Demande d'essai pour",
      "demande-d-essai-retiree_640e75": "Demande d'essai retirée",
      "demande-de-devis-de_4122de": "Demande de devis de",
      "demande-de-devis-envoyee_3f16be": "Demande de devis envoyée ✓",
      "demande-de-report-du-ret_6d8285": "Demande de report du retrait pour",
      "demande-de-report-envoye_03bf02": "Demande de report envoyée.",
      "demande-de-reservation-a_e2dde6": "Demande de réservation après offre acceptée pour",
      "demande-de-reservation-e_41b342": "Demande de réservation envoyée ✓",
      "demande-de-reservation-p_f04696": "Demande de réservation pour",
      "demande-de-reservation-r_41adf8": "Demande de réservation retirée",
      "demande-de-visite-de_f9eeab": "Demande de visite de",
      "demande-de-visite-envoye_671e80": "Demande de visite envoyée ✓",
      "demande-de-visite-retire_027a5a": "Demande de visite retirée",
      "desactive-aucun-utilisat_ba2e35": "Désactivé : aucun utilisateur n'est bloqué par le rythme de publication.",
      "desactiver_9d314e": "Désactiver",
      "desactives_c22267": "Désactivés",
      "description-peu-coherent_3f0881": "Description peu cohérente avec la catégorie choisie",
      "detail-serveur-cartons-r_66eff9": "Détail serveur (cartons · rachats · pénalité) + barème éditable",
      "detecte_a55e8c": "détecté",
      "donnez-votre-version_5aae5e": "donnez votre version.",
      "doublon_dbc50f": "Doublon",
      "du-bien_b92f31": "du bien",
      "du-vehicule_292311": "du véhicule",
      "e-mail_d7249e": "E-mail",
      "echange-recent_7eb14b": "Échange récent",
      "echec-de-l-enregistremen_270e48": "Échec de l'enregistrement. Réessayez.",
      "email-de-reinitialisatio_3c392f": "Email de réinitialisation impossible.",
      "email-de-reinitialisatio_9349d1": "Email de réinitialisation envoyé. Ouvrez le lien reçu pour définir un nouveau mot de passe.",
      "email-de-validation-envo_5bd2e4": "Email de validation envoyé. Vérifiez votre boîte mail.",
      "email-invalide_7ecdc5": "Email invalide.",
      "email-valide-votre-compt_84253d": "Email validé. Votre compte est débloqué.",
      "email-verifie-automatiqu_bfb6d6": "Email vérifié automatiquement. Vous pouvez publier dès maintenant.",
      "emails-automatiques-acti_e8c056": "Emails automatiques activés",
      "emails-automatiques-desa_05671a": "Emails automatiques désactivés",
      "emails-automatiques_e1fa83": "Emails automatiques",
      "en-attente-de-verificati_2cb663": "En attente de vérification",
      "en-attente-du-proprietai_a28fdf": "en attente du propriétaire",
      "en-attente-du-vendeur_a654a6": "en attente du vendeur",
      "en-un-coup-d-il_65f0f2": "En un coup d'œil",
      "encore-une-etape_c65b7d": "Encore une étape",
      "encre-chaude-photos-mise_2c1db3": "Encre chaude, photos mises en valeur, reposant le soir.",
      "enregistrement_442243": "Enregistrement...",
      "enregistrer-le-nouveau-m_381a63": "Enregistrer le nouveau mot de passe",
      "entrez-le-code-a-6-chiff_f7a575": "Entrez le code à 6 chiffres reçu par email pour débloquer les fonctionnalités protégées.",
      "entrez-les-6-chiffres-du_c8a429": "Entrez les 6 chiffres du code.",
      "entrez-votre-code_72380c": "Entrez votre code",
      "envoi_8d2e8c": "Envoi...",
      "envoyer-l-email-de-reini_2c26ba": "Envoyer l'email de réinitialisation",
      "erreur-de-synchronisatio_bb3402": "Erreur de synchronisation, réessayez.",
      "essai-annule_10925f": "Essai annulé",
      "essai-confirme_4b0b34": "Essai confirmé",
      "essai-deja-demande_a92399": "Essai déjà demandé",
      "essai-realise-confirme-d_ea171f": "Essai réalisé, confirmé de votre côté.",
      "essai-realise-confirme-p_192854": "Essai réalisé, confirmé par le vendeur.",
      "evaluations_f86103": "Évaluations",
      "evaluer-une-autre-transa_f07e83": "＋ Évaluer une autre transaction",
      "expiree_80e317": "Expirée",
      "expiree_ef42be": "expirée",
      "explorer-d-abord_f5bc81": "Explorer d'abord",
      "faible-risque_9db781": "Faible risque",
      "fermer_b89077": "Fermer",
      "fond-creme-l-identite-la_17a385": "Fond crème, l'identité LANAC d'origine.",
      "forfait-pulse-mis-a-jour_49ce87": "Forfait Pulse mis à jour",
      "forfait-pulse-de-ce-comp_bffbe5": "Forfait Pulse de ce compte (durée d'activation maximale).",
      "formats-acceptes-jpg-png_4900c1": "Formats acceptés : JPG, PNG ou WebP.",
      "fraude-possible_a8e3bf": "Fraude possible",
      "gratuit_95b6d5": "Gratuit",
      "heure-de_c5acf2": "Heure de ",
      "impossible-de-charger-le_beecca": "Impossible de charger les annonces.",
      "impossible-de-renvoyer-l_56e934": "Impossible de renvoyer l'email depuis cette session.",
      "in-app_7f41c2": "In-app",
      "c-est-enregistre-l-annon_9c560f": "C'est enregistré. L'annonce est de nouveau disponible.",
      "indice-de-confiance_c8cf0a": "Indice de confiance",
      "indisponible-ville-utili_ae4dfa": "Indisponible — ville utilisée",
      "informations-vehicule-in_2bbfc5": "Informations véhicule incomplètes (marque, modèle, année ou kilométrage)",
      "informations_ed11c2": "INFORMATIONS",
      "j-ai-annule_96ee1e": "J'ai annulé",
      "j-aime-ajoute_05d4fc": "J'aime ajouté",
      "j-aime-retire_107c23": "J'aime retiré.",
      "j-etais-absent_fe61f4": "J'étais absent",
      "j-etais-present_7d7c92": "J'étais présent",
      "je-confirme_c6ee32": "Je confirme",
      "je-n-ai-pas-annule_a17b5b": "Je n'ai pas annulé",
      "je-ne-confirme-pas_069b01": "Je ne confirme pas",
      "jean-dupont_a689f0": "Jean Dupont",
      "kilometrage-tres-eleve-o_14dbf2": "Kilométrage très élevé ou incohérent",
      "l-achat-du-vehicule_18a695": "l'achat du véhicule",
      "l-acheteur-propose-un-au_2f5454": "L'acheteur propose un autre essai",
      "l-acheteur-propose-un-au_377885": "L'acheteur propose un autre créneau",
      "l-acheteur_d296f2": "L'acheteur",
      "l-action-n-a-pas-pu-etre_da76c2": "L'action n'a pas pu être enregistrée côté serveur. Réessayez.",
      "l-algorithme-verifie-tou_d25d58": "L'algorithme vérifie toujours profil, prix, cohérence, doublons, spam, photos, liens externes et paiement suspect. Les annonces propres passent automatiquement ; les cas risqués arrivent ici pour validation admin.",
      "l-annonce-est-de-nouveau_535b1e": "L'annonce est de nouveau disponible et l'autre partie doit confirmer cette information.",
      "l-annonce-est-de-nouveau_d4d3d8": "L'annonce est de nouveau disponible. Merci à l'autre partie de confirmer cette information.",
      "l-article-ne-convient-pa_853903": "l'article ne convient pas à l'acheteur",
      "l-article-ne-convient-pa_ba7d7f": "L'article ne convient pas à l'acheteur",
      "l-article-ne-me-convient_281077": "L'article ne me convient pas",
      "l-article-ne-vous-convie_82c0ea": "l'article ne vous convient pas",
      "l-article_5ac9ef": "l'article",
      "l-autre-partie-devra-con_17aba7": "L'autre partie devra confirmer avant de changer le statut de l'annonce. Continuer ?",
      "l-autre-partie-indique-u_55f93e": "L'autre partie indique une annulation de votre côté. Si c'est exact, choisissez « J'ai annulé » ; sinon « Je n'ai pas annulé » ; si vous vous êtes arrangés, « Problème résolu ».",
      "l-avis-n-a-pas-pu-etre-e_037c92": "L'avis n'a pas pu être enregistré. Vérifiez votre connexion.",
      "l-avis-n-a-pas-pu-etre-e_497537": "L'avis n'a pas pu être enregistré. Réessayez dans un instant.",
      "l-essai_9c4603": "l'essai",
      "la-confirmation-n-a-pas_13bcc2": "La confirmation n'a pas pu etre enregistree. Rechargez la page et reessayez.",
      "la-decision-n-a-pas-pu-e_206a9f": "La décision n'a pas pu être enregistrée. Réessayez.",
      "la-location_586401": "la location",
      "la-mise-a-disposition_4bd52d": "la mise à disposition",
      "la-mise-en-location_e263d9": "la mise en location",
      "la-reservation-a-expire_142337": "La réservation a expiré — l'annonce est de nouveau disponible.",
      "la-reservation-reste-val_1f9b3f": "la réservation reste valable jusqu'à son échéance",
      "la-suppression-a-echoue_26fe3f": "La suppression a échoué. Réessayez plus tard.",
      "la-suppression-a-echoue_884fe3": "La suppression a échoué (réseau). Réessayez.",
      "la-transaction-pour-le-b_986e7a": "la transaction pour le bien",
      "la-vente_cf27de": "la vente ",
      "la-visite-a-eu-lieu-le-b_e5fc68": "La visite a eu lieu. Le bien vous intéresse-t-il toujours et la location / vente a-t-elle avancé ?",
      "la-visite_2591e0": "la visite",
      "le-bien-immobilier-ne-co_658900": "le bien immobilier ne convient pas au client",
      "le-bien-immobilier-ne-me_2ca949": "Le bien immobilier ne me convient pas",
      "le-bien-immobilier-ne-vo_a0815a": "le bien immobilier ne vous convient pas",
      "le-bien-ne-convient-pas_a10a22": "Le bien ne convient pas au client",
      "le-bien_ac2a1f": "le bien",
      "le-locataire_ccdb2e": "Le locataire",
      "le-proprietaire_8f1f3d": "Le propriétaire",
      "le-retrait-et-l-achat-de_76a817": "le retrait et l'achat de l'article",
      "le-retrait-n-a-pas-pu-et_fd9e3e": "Le retrait n'a pas pu être enregistré. Réessayez.",
      "le-retrait_838a2e": "le retrait",
      "le-vehicule-ne-convient_6943b5": "le véhicule ne convient pas à l'acheteur",
      "le-vehicule-ne-convient_f44469": "Le véhicule ne convient pas à l'acheteur",
      "le-vehicule-ne-me-convie_b88085": "Le véhicule ne me convient pas",
      "le-vehicule-ne-vous-conv_c62f9d": "le véhicule ne vous convient pas",
      "le-vehicule_aabb1d": "le véhicule",
      "le-vendeur_291ee8": "Le vendeur",
      "les-avis-sont-disponible_a29b87": "Les avis sont disponibles après une transaction confirmée.",
      "les-mots-de-passe-ne-cor_f0ee96": "Les mots de passe ne correspondent pas.",
      "lien-copie_a12091": "Lien copié.",
      "localisation_419b87": "Localisation…",
      "localisation_75883c": "Localisation…",
      "localisation_a697d1": "Localisation",
      "location-realisee_4affc1": "Location réalisée",
      "location_5ac955": "location",
      "masquer-le-mot-de-passe_e14a59": "Masquer le mot de passe",
      "medias-decisions-rpc-ema_640ade": "Médias, décisions RPC, emails, protection, rythme de publication",
      "membre-depuis_17f65a": "Membre depuis",
      "merci-pour-votre-j-aime_bfcd24": "Merci pour votre j'aime.",
      "message-admin_ab1dac": "Message admin",
      "message-envoye_54c6ee": "✓ Message envoyé !",
      "messages_35d503": "Messages",
      "minimum-8-caracteres_9e292d": "Minimum 8 caractères.",
      "modification-admin-mise_56383a": "Modification admin mise en attente : produit ou signal interdit détecté",
      "modification-en-attente_5837da": "Modification en attente d'approbation",
      "modification-en-verifica_68b850": "Modification en vérification",
      "modification-enregistree_8485d8": "Modification enregistrée",
      "modification-soumise-en_4c3583": "Modification soumise — en cours de vérification",
      "modification_9ba57f": "Modification...",
      "modifier-l-annonce_2a41c3": "Modifier l'annonce",
      "modifier_d9ff4a": "Modifier",
      "mon-activite_5f1e16": "Mon activité",
      "mot-de-passe-modifie-vou_2a6057": "Mot de passe modifié. Vous pouvez continuer.",
      "mot-de-passe-oublie_c780b0": "Mot de passe oublié ?",
      "moyenne_4a1ac9": "moyenne",
      "n-avis_ee6b03": "{n} avis",
      "n-verifie-s_69fbe6": "{n} vérifié{s}",
      "no-show-acheteur-signale_79120d": "No-show acheteur signalé",
      "no-show-acheteur_687a42": "No-show acheteur",
      "no-show-essai-signale_5dca75": "No-show essai signalé",
      "no-show-essai_53d67b": "No-show essai",
      "no-show-signale-au-rende_90d83d": "No-show signalé au rendez-vous de vente / retrait.",
      "no-show-visite-signale_c5a767": "No-show visite signalé",
      "no-show-visite_eb156a": "No-show visite",
      "no-shows_901376": "No-shows",
      "nom-public_1a8853": "Nom public",
      "nombre-maximum-de-demand_35752c": "Nombre maximum de demandes atteint pour cette annonce.",
      "non-approuvees-revision_59d438": "Non approuvées — révision possible",
      "note-moyenne-laissee-par_ca3d70": "Note moyenne laissée par les acheteurs après une transaction.",
      "note-moyenne_d4f6a7": "Note moyenne",
      "note-vous-partagerez-l-a_27d48b": "Noté ✓ — vous partagerez l'adresse plus tard.",
      "notifications-push-activ_244c33": "Notifications push activées sur cet appareil.",
      "nous-avons-envoye-un-cod_de9cd9": "Nous avons envoyé un code à 6 chiffres à votre adresse email. Saisissez-le ci-dessous.",
      "nouveau-creneau-d-essai_fca941": "Nouveau créneau d'essai proposé",
      "nouveau-creneau-de-visit_9dcbd7": "Nouveau créneau de visite proposé",
      "nouveau-creneau-envoye_6e5a24": "Nouveau créneau envoyé",
      "nouveau-message_bc4fa3": "Nouveau message",
      "nouveau-mot-de-passe_df82af": "Nouveau mot de passe",
      "nouveau-retrait-le_f755fd": "nouveau retrait le",
      "nouveau-retrait_d871dd": "nouveau retrait",
      "nouveaux-utilisateurs_63c16d": "Nouveaux utilisateurs",
      "nouvelle-annonce-pour-vo_f37fe7": "Nouvelle annonce pour votre alerte",
      "nouvelle-annonce-proche_f68554": "Nouvelle annonce proche de votre recherche",
      "offre-de_7a9928": "Offre de",
      "offre-deja-en-cours_6346ee": "Offre déjà en cours",
      "offre-envoyee_c20ce4": "Offre envoyée ✓",
      "offre-retiree_be49b0": "Offre retirée.",
      "ok_45a40c": "OK",
      "options_b427bc": "Options",
      "ou-une-ville-une-commune_6c0efa": "Où ? une ville, une commune…",
      "ouvertures-de-fiches_39ffe7": "Ouvertures de fiches",
      "ouvrir-l-annonce_d79b2c": "Ouvrir l'annonce",
      "palier-de-confiance_3edd1d": "Palier de confiance",
      "par-type-de-notification_e5f76b": "Par type de notification",
      "partager-mon-profil_88637e": "Partager mon profil",
      "pas-encore-d-avis_1b70b7": "Pas encore d'avis",
      "passeport-de-confiance_9e8827": "Passeport de confiance",
      "penalite_e0b8d6": "Pénalité",
      "permettre-a-ce-compte-de_81625a": "Permettre à ce compte de publier sans passer en validation après 3 annonces en 24h.",
      "petite-banniere-en-haut_8343d1": "Petite bannière en haut quand un message arrive pendant que vous naviguez dans l'app.",
      "photo_5f0688": "Photo",
      "photo_6365c1": "Photo",
      "photos_2489d8": "photos",
      "plus-tard_42b3f5": "Plus tard",
      "points-a-corriger_2cfc19": "Points à corriger :",
      "ponctuation-excessive-da_d12edc": "Ponctuation excessive dans le titre",
      "position-activee-desacti_115bf2": "Position activée — désactiver",
      "pour-cloturer-l-echange_5db8d6": "Pour clôturer l'échange et débloquer les avis vérifiés, confirmez à votre tour depuis la carte « Transaction à confirmer ».",
      "prix-a-debattre_adcc92": "Prix à débattre",
      "prix-hors-fourchette-hab_2772e2": "Prix hors fourchette habituelle pour cette catégorie",
      "prix-incoherent_ada882": "Prix incohérent",
      "prix-inferieur-aux-annon_f9dd22": "Prix inférieur aux annonces similaires",
      "prix-legerement-inferieu_d58803": "Prix légèrement inférieur aux annonces similaires",
      "probleme-resolu_cffd18": "Problème résolu",
      "profil-avis_38da42": "Profil & avis",
      "profil-complete_60930e": "✓ Profil complété.",
      "profil-controle-par-l-ad_4ced6c": "Profil contrôlé par l'admin. Email et téléphone restent séparés.",
      "profil-controle_2d67ef": "Profil contrôlé",
      "profil-valide-annonce-pu_86218d": "✓ Profil validé — annonce publiée automatiquement !",
      "progression-de-la-video_c9b2cb": "Progression de la vidéo",
      "proprietaire_c768e0": "propriétaire",
      "protection-automatique-p_523329": "Protection automatique permanente",
      "publication-en-validatio_09a701": "Publication en validation admin : limite de 3 publications en 24h atteinte.",
      "push-sur-cet-appareil_55239e": "Push sur cet appareil",
      "rachats_d1d9e9": "Rachats",
      "rappel-merci-de-confirme_e9d134": "Rappel : merci de confirmer si le rendez-vous / la réservation a bien eu lieu.",
      "rappels-d-avis_728e60": "Rappels d'avis",
      "rayon-10-km_ce731e": "Rayon 10 km",
      "rayon-25-km_1e8a9c": "Rayon 25 km",
      "rayon-5-km_ed34ca": "Rayon 5 km",
      "rayon-50-km_ab4897": "Rayon 50 km",
      "reactiver-controle_853ecf": "Réactiver contrôle",
      "recevoir-mon-code-de-con_74fa8d": "Recevoir mon code de confirmation",
      "recherche-recente_c0c041": "Recherche récente",
      "recherche-visuelle-appli_aec3ab": "Recherche visuelle appliquée.",
      "recherches-recentes_45cd3f": "Recherches récentes",
      "reessayer-dans_fdbfdf": "Réessayer dans",
      "reessayer_19c235": "Réessayer",
      "refusee_e5bee7": "Refusée",
      "refuser-cette-confirmati_fc9bda": "Refuser cette confirmation après visite ?",
      "reglages-securite_8c889e": "Réglages & sécurité",
      "rendez-vous-annule-l-ann_c8573d": "Rendez-vous annulé. L'annonce est de nouveau disponible.",
      "rendez-vous-annule_07f186": "Rendez-vous annulé",
      "repetition-excessive-de_277837": "Répétition excessive de mots-clés",
      "reponse-envoyee_5c79f2": "Réponse envoyée",
      "report-du-retrait-accept_a243bb": "Report du retrait accepté",
      "report-du-retrait-confir_f92be3": "Report du retrait confirmé",
      "reports_39b968": "Reports",
      "reservation-acceptee_198b3d": "Réservation acceptée",
      "reservation-annulee_95a64f": "Réservation annulée",
      "reservation-confirmee_96dc9e": "Réservation confirmée",
      "reservation-deja-demande_f632e4": "Réservation déjà demandée",
      "reservation_276a83": "Réservation",
      "reservee-retiree_2205db": "réservée / retirée",
      "resultats-trouves_8a7eec": "Résultats trouvés",
      "resume-du-matin_404951": "Résumé du matin",
      "retire-des-favoris_213a39": "Retiré des favoris.",
      "retirer-controle_f749b1": "Retirer contrôle",
      "retirer-des-favoris_933036": "Retirer des favoris",
      "retrait-confirme-l-autre_d47eeb": "Retrait confirmé. L'autre partie doit confirmer la transaction pour débloquer les avis.",
      "retrait-confirme_2e3fca": "Retrait confirmé",
      "retrait_6c6d56": "retrait",
      "retrouvez-la-dans-vos-me_0ecf36": "Retrouvez-la dans vos messages.",
      "rien-de-choisi-annonces_30d80a": "Rien de choisi → annonces près de vous",
      "risque-eleve_971f44": "Risque élevé",
      "role_458d33": "Rôle",
      "rouvrir_5b551a": "Rouvrir",
      "rythme-debloque_a00351": "RYTHME DÉBLOQUÉ",
      "rythme-publication-contr_ef7f5d": "Rythme publication contrôlé",
      "rythme-publication-deblo_09a5be": "Rythme publication débloqué",
      "samedi_acfc23": "Samedi",
      "sans-reponse-du-vendeur_742b3e": "sans réponse du vendeur — cela n'entame pas votre quota de demandes",
      "score-risque_667e6d": "Score risque",
      "service-d-authentificati_562329": "Service d'authentification indisponible.",
      "service-de-validation-in_ea82f1": "Service de validation indisponible.",
      "service-indisponible_fe26d5": "Service indisponible.",
      "service-non-disponible_bf6528": "Service non disponible.",
      "service-travaux-trop-peu_70c2c4": "Service/travaux trop peu détaillé pour évaluer le sérieux",
      "seul-l-acheteur-concerne_e3df8e": "Seul l'acheteur concerné peut reporter le retrait.",
      "seul-l-acheteur-peut-con_0bf15b": "Seul l'acheteur peut confirmer l'achat / le retrait.",
      "seul-l-acheteur-peut-lan_581106": "Seul l'acheteur peut lancer la réservation après acceptation de l'offre.",
      "seul-le-vendeur-peut-con_6ebf40": "Seul le vendeur peut confirmer la vente.",
      "seul-le-vendeur-peut-sig_97c56d": "Seul le vendeur peut signaler un no-show client.",
      "signalement-de-conversat_cb320e": "Signalement de conversation envoyé.",
      "signalement-depuis-la-ca_dbba5a": "Signalement depuis la carte de visite",
      "signalement-depuis-la-ca_ee859d": "Signalement depuis la carte de réservation",
      "signalement-envoye-merci_8e738d": "Signalement envoyé. Merci.",
      "signalement-envoye_a31d33": "Signalement envoyé",
      "signalement-reservation_62fd1f": "Signalement réservation",
      "signalement-visite_fb27fd": "Signalement visite",
      "sombre_228cbd": "Sombre",
      "sous-compromis_6e2fe7": "Sous compromis",
      "statut-incompatible-avec_00325d": "Statut incompatible avec cette annonce.",
      "statut-mis-a-jour_a2788f": "Statut mis à jour",
      "suggestions_532166": "Suggestions",
      "suit-le-mode-clair-sombr_bd0afb": "Suit le mode clair/sombre de votre appareil.",
      "suivre_742bd6": "+ Suivre",
      "suppression-impossible-u_892b8b": "Suppression impossible : une demande de réservation que vous avez envoyée attend encore une réponse. Retirez-la d'abord.",
      "suppression-impossible-d_8ac51c": "Suppression impossible : des échanges sont encore en cours.",
      "suppression-impossible-v_bea5cd": "Suppression impossible : vous avez une transaction en cours. Terminez-la d'abord.",
      "supprimer-definitivement_d6fef7": "Supprimer définitivement cette annonce refusée ?",
      "supprimer-definitivement_e39e44": "Supprimer définitivement",
      "supprimer_72845b": "Supprimer",
      "supprimer_8e906c": "Supprimer",
      "sur-iphone-ipad-ajoutez_9e364f": "Sur iPhone/iPad, ajoutez Lanac à l'écran d'accueil (Partager → « Sur l'écran d'accueil ») pour recevoir les notifications push.",
      "surface-manquante-pour-u_f1b7e6": "Surface manquante pour une annonce immobilière",
      "synchronisation-indispon_4a9e9f": "Synchronisation indisponible, réessayez.",
      "telephone_145c7a": "Téléphone",
      "titre-entierement-en-maj_841389": "Titre entièrement en majuscules",
      "total-comptes_6bceb7": "Total comptes",
      "toujours-actif_acbca6": "Toujours actif",
      "tous-les-prix_ad2d8c": "Tous les prix",
      "tout-marquer-lu_e98c65": "Tout marquer lu",
      "tout_64cc26": "Tout",
      "toutes-nouvelles-annonce_4b4b4c": "Toutes nouvelles annonces",
      "toutes-villes_8c4409": "Toutes villes",
      "traiter_0a00f8": "Traiter",
      "transaction-evaluee_c935be": "Transaction évaluée",
      "transactions_6d3f69": "Transactions",
      "trop-d-annulations-de-re_ed56c2": "Trop d'annulations de rendez-vous récentes. Réessayez plus tard.",
      "trop-d-annulations-recen_c47802": "Trop d'annulations récentes. Réessayez plus tard.",
      "trop-de-demandes-merci-d_a771ab": "Trop de demandes. Merci d'attendre quelques instants avant de redemander un email.",
      "trop-de-montants-symbole_64bc0d": "Trop de montants/symboles dans la description",
      "trust-score-utilisateurs_fb7c21": "Trust score utilisateurs",
      "un-acheteur-tient-la-res_318477": "Un acheteur tient la réservation : le statut n'a pas changé. Pour l'annuler, passez par la conversation.",
      "un-acheteur-tient-la-res_8b7ece": "Un acheteur tient la réservation : l'annonce n'a pas été supprimée. Pour l'annuler, passez par la conversation.",
      "annuler-la-reservation-e_47d2a4": "Annuler la réservation en cours ?",
      "un-acheteur-a-une-reserv_ad0170": "Un acheteur a une réservation acceptée sur cette annonce. Marquer l'annonce « {statut} » annule cette réservation. L'acheteur est prévenu tout de suite, et cette annulation est prise en compte : elle peut impacter votre score de confiance.",
      "garder-la-reservation_628daf": "Garder la réservation",
      "clore-la-demande-de-rese_a806eb": "Clore la demande de réservation ?",
      "un-acheteur-attend-votre_f1d1c7": "Un acheteur attend votre réponse à sa demande de réservation. Marquer l'annonce « {statut} » clôt cette demande, et l'acheteur en est prévenu tout de suite.",
      "ne-rien-changer_e54d43": "Ne rien changer",
      "marquer-statut_495e24": "Marquer « {statut} »",
      "l-acheteur-a-confirme-le_6026c8": "L'acheteur a confirmé le retrait : le statut n'a pas changé. Confirmez la transaction dans la conversation.",
      "un-annonceur_a14578": "un annonceur",
      "un-compte-admin-ne-peut_f09759": "Un compte admin ne peut pas être bloqué ici.",
      "une-absence-a-ete-signal_5068bc": "Une absence a été signalée. Chaque partie donne sa version.",
      "une-action-finale-est-de_7c3a9b": "Une action finale est déjà enregistrée pour cette réservation.",
      "une-annulation-a-ete-sig_c4c7b0": "Une annulation a été signalée. Chaque partie donne sa version.",
      "urgent_1b6a7a": "Urgent",
      "utilisateur-bloque_6d4840": "Utilisateur bloqué",
      "utilisateur-bloque_a496d8": "Utilisateur bloqué.",
      "utilisateur-bloque_a91f8f": "Utilisateur bloqué",
      "utilisateur-debloque_88742a": "Utilisateur débloqué.",
      "utilisateur-debloque_d9c645": "Utilisateur débloqué",
      "utilisateur-inconnu_4deb6c": "Utilisateur inconnu",
      "utilisateurs_7489b5": "Utilisateurs",
      "utiliser-ma-position-pre_8ca56e": "Utiliser ma position précise",
      "utiliser-ma-position_fa80ff": "Utiliser ma position",
      "validation-email-impossi_051b8d": "Validation email impossible.",
      "validation-impossible_31080d": "Validation impossible.",
      "validation-telephone-opt_8505e2": "Validation téléphone : optionnelle au lancement. Activation ciblée prévue depuis le panel admin pour comptes à risque, vendeurs pro, catégories sensibles et signalements répétés.",
      "vehicule-disponible-a-no_f15d84": "Véhicule disponible à nouveau",
      "vehicule-ne-convient-pas_a9b175": "Véhicule ne convient pas",
      "vehicule-reserve-retrait_55a2b9": "véhicule réservé · retrait le",
      "vendeur_768502": "vendeur",
      "vendue_de981b": "vendue",
      "vendus-loues-realises_9e67d6": "Vendus, loués, réalisés",
      "vente-a-confirmer-par-l_09b400": "Vente à confirmer par l'acheteur",
      "vente-realisee_f93e9b": "Vente réalisée",
      "ventes-conclues_d851f3": "Ventes conclues",
      "verification-admin_f42913": "Vérification admin",
      "verifications_0a1a6c": "VÉRIFICATIONS",
      "verifie-par-l-equipe_e1f993": "Vérifié par l'équipe",
      "video_12268a": "vidéo",
      "ville-exacte_da15de": "Ville exacte",
      "ville_7d73ed": "Ville",
      "visite-confirmee_38e834": "Visite confirmée",
      "visite-deja-demandee_7e706f": "Visite déjà demandée",
      "visite-realisee-confirme_1bc020": "Visite réalisée, confirmée de votre côté.",
      "visite-realisee-confirme_2e5c1a": "Visite réalisée, confirmée par le propriétaire.",
      "visite-realisee-confirme_6e1977": "Visite réalisée, confirmée par le vendeur.",
      "visitee_262a5e": "visitée",
      "visiteurs-site_576941": "Visiteurs site",
      "voir-l-annonce_56da11": "Voir l'annonce",
      "voir-plus_08912e": "Voir plus",
      "voir_4a41bd": "Voir",
      "vos-evaluations-apparait_10b749": "Vos évaluations apparaîtront ici après vos premières transactions.",
      "votre-message-a-ete-envo_74313a": "Votre message a été envoyé à l'administration.",
      "votre-ville_ca1dd7": "Votre ville…",
      "vous-allez-confirmer-la_45f8e5": "Vous allez confirmer la location et le retrait. Cette action est irrévocable. Continuer ?",
      "vous-allez-retirer-cette_95b6f1": "Vous allez retirer cette offre. Il vous restera une offre pour cette annonce. Continuer ?",
      "vous-allez-retirer-cette_a6dd34": "Vous allez retirer cette offre. Après cela, vous ne pourrez plus faire d'offre sur cette annonce, mais vous pourrez toujours la réserver. Continuer ?",
      "vous-avez-deja-evalue-ce_d532fc": "Vous avez déjà évalué cette transaction.",
      "vous-avez-deja-propose-d_603f4b": "Vous avez déjà proposé deux offres pour cette annonce. Vous pouvez toujours la réserver ou contacter le vendeur.",
      "vous-avez-deja-une-deman_73e747": "Vous avez déjà une demande en cours pour cette annonce.",
      "vous-avez-signale-une-an_156bf0": "Vous avez signalé une annulation. En attente de la réponse de l'autre partie.",
      "vous-confirmez-cote-vend_cead97": "Vous confirmez côté vendeur que l'essai a eu lieu. Continuer ?",
      "vous-confirmez-en-tant-q_b25139": "Vous confirmez, en tant que propriétaire, que la visite a eu lieu. Continuer ?",
      "vous-confirmez-en-tant-q_bee2fa": "Vous confirmez, en tant que vendeur, que la visite a eu lieu. Continuer ?",
      "vous-confirmez-que-l-ess_3bd7bd": "Vous confirmez que l'essai a eu lieu. Continuer ?",
      "vous-confirmez-que-la-vi_0f4004": "Vous confirmez que la visite a eu lieu. Continuer ?",
      "vous-mail-lu_f17876": "vous@mail.lu",
      "vous-n-avez-pas-encore-d_25a04a": "Vous n'avez pas encore d'abonnés.",
      "vous-ne-pouvez-pas-bloqu_40daf4": "Vous ne pouvez pas bloquer votre propre compte admin.",
      "vous-ne-pouvez-pas-vous_247868": "Vous ne pouvez pas vous contacter.",
      "vous-ne-suivez-personne_cdce63": "Vous ne suivez personne pour l'instant.",
      "vous-partagerez-l-adress_a4c110": "vous partagerez l'adresse plus tard",
      "vous-serez-prevenu-si-l_99eb78": "Vous serez prévenu si l'article redevient disponible.",
      "vues-annonces_bf6811": "Vues annonces",
      "zone-sensible_c93bf1": "Zone sensible",
      "conclue_4e7ad8": "Conclue",
      "en-cours_aeb975": "En cours",
      "litige_cb6d2c": "Litige",
      "rendez-vous_824ad1": "Rendez-vous",
      "reserve_bdc71c": "Réservé",
      "sans-suite_4e6163": "Sans suite",
      "sponsorise_845fbe": "Sponsorisé",
      "modification-non-enregis_e8686b": "Modification non enregistrée. Réessayez.",
      "la-transaction-liee-n-a_db2bfa": "La transaction liée n'a pas pu être archivée.",
      "la-transaction-n-a-pas-p_a510b9": "La transaction n'a pas pu être marquée en litige.",
      "l-alerte-de-disponibilit_92b780": "L'alerte de disponibilité n'a pas pu être enregistrée. Réessayez.",
      "vous-avez-deja-signale-c_bbd25e": "Vous avez déjà signalé cette annonce. C'est bien noté.",
      "vous-avez-deja-signale-c_58372c": "Vous avez déjà signalé cette conversation. C'est bien noté.",
      "signalement-non-envoye-c_60d022": "Signalement non envoyé : connexion impossible. Réessayez.",
      "trop-de-signalements-auj_093da0": "Trop de signalements aujourd'hui. Réessayez demain.",
      "ce-signalement-ne-peut-p_946cb9": "Ce signalement ne peut pas être envoyé.",
      "classer-sans-suite_e4f9de": "Classer sans suite",
      "sanctionner-la-fraude_19df07": "Sanctionner la fraude",
      "revenir-sur-la-sanction_f2c0d0": "Revenir sur la sanction",
      "histoire_9e370b": "Histoire",
      "confirmer-la-sanction_8b0cbf": "Confirmer la sanction",
      "retirer-la-sanction_b818ca": "Retirer la sanction",
      "classer-ce-signalement-s_e6a0a7": "Classer ce signalement sans suite ? Il reste dans l'historique et la personne signalée n'est pas pénalisée.",
      "raison-obligatoire-consi_596098": "Raison (obligatoire, consignée dans l'histoire du dossier)",
      "penalite-sur-le-score-de_6e1ab1": "Pénalité sur le score de confiance de la personne signalée :",
      "reversible-avec-une-rais_5b5622": "Réversible, avec une raison. Recalcul sous 5 minutes.",
      "la-penalite-sera-retiree_62d193": "La pénalité sera retirée du score de confiance (recalcul sous 5 minutes).",
      "ecrivez-une-raison-3-car_396e00": "Écrivez une raison (3 caractères au moins).",
      "classe-sans-suite_948e70": "Classé sans suite",
      "litige-entre-membres-reg_b15c17": "Litige entre membres · règles automatiques",
      "en-cours-entre-les-parti_c5f06c": "En cours entre les parties",
      "reconnu_a7d7e4": "Reconnu",
      "conteste-benefice-du-dou_efe053": "Contesté · bénéfice du doute",
      "expire-benefice-du-doute_d3f7f0": "Expiré · bénéfice du doute",
      "regle-entre-les-parties_68c49c": "Réglé entre les parties",
      "sans-reponse_c2d081": "Sans réponse",
      "signalement-classe-sans_e902b0": "Signalement classé sans suite.",
      "fraude-sanctionnee-le-sc_173615": "Fraude sanctionnée. Le score de confiance sera recalculé sous 5 minutes.",
      "sanction-retiree-le-scor_7404d6": "Sanction retirée. Le score de confiance sera recalculé sous 5 minutes.",
      "ce-signalement-a-deja-et_a7a8b5": "Ce signalement a déjà été modéré entre-temps : l'écran est à jour.",
      "un-litige-entre-membres_46fb9d": "Un litige entre membres ne se modère pas : il suit les règles automatiques.",
      "moderation-non-enregistr_9b97bb": "Modération non enregistrée. Réessayez.",
      "aucun-evenement-consigne_969f06": "Aucun événement consigné (le journal existe depuis le 13/09/2026).",
      "histoire-indisponible-re_86956f": "Histoire indisponible. Réessayez.",
      "chargement_ebb1b7": "Chargement…",
      "depose_320806": "Déposé",
      "fraude-sanctionnee_1aa31f": "Fraude sanctionnée",
      "sanction-retiree_258fbb": "Sanction retirée",
      "rouvert_3dda01": "Rouvert",
      "clos-sans-reponse_b2e53c": "Clos sans réponse",
      "clos_039bb2": "Clos",
      "reponse-d-une-partie_d426ea": "Réponse d'une partie",
      "preuves-effacees-duree-d_32fe43": "Preuves effacées (durée de conservation)",
      "modifie_4ab42d": "Modifié",
      "supprime_398bce": "Supprimé",
      "membre_c1e390": "membre",
      "membre-par-le-serveur_5adec9": "membre, par le serveur",
      "administration_06578b": "administration",
      "automatique_6d4366": "automatique",
      "rien-n-a-ete-enregistre_4fe765": "Rien n'a été enregistré : connexion impossible. Réessayez.",
      "connexion-impossible-ce_25b35c": "Connexion impossible : ce geste n'a peut-être pas abouti. Le refaire ne l'enregistrera jamais deux fois.",
      "cela-ne-peut-pas-etre-en_5697a1": "Cela ne peut pas être enregistré.",
      "cette-reponse-ne-peut-pa_b7b166": "Cette réponse ne peut pas être enregistrée.",
      "cet-echange-ne-peut-plus_61bb75": "Cet échange ne peut plus recevoir de réponse : il se clôt de lui-même.",
      "contestation-impossible_242ca8": "Contestation impossible tant que l'autre partie n'a pas répondu.",
      "vous-pourrez-le-confirme_6a5512": "Vous pourrez le confirmer à partir de l'heure du rendez-vous.",
      "vous-avez-envoye-beaucou_edb082": "Vous avez envoyé beaucoup de photos aujourd'hui : vous pourrez en envoyer de nouveau dans {delai}.",
      "trop-d-envois-en-peu-de_eea5ac": "Trop d'envois en peu de temps : patientez une minute, puis réessayez.",
      "un-fichier-est-trop-lour_3f0180": "Un fichier est trop lourd pour être envoyé.",
      "ce-format-de-fichier-n-e_12a58e": "Ce format de fichier n'est pas accepté.",
      "vos-photos-ou-votre-vide_4befb1": "Vos photos ou votre vidéo n'ont pas pu être envoyées : vérifiez votre connexion, puis réessayez.",
      "rien-n-a-ete-publie-vos_6ab845": "Rien n'a été publié : vos informations sont conservées.",
      "votre-modification-n-a-p_93f0b2": "Votre modification n'a pas été enregistrée.",
      "votre-modification-n-a-p_784d2b": "Votre modification n'a pas été enregistrée : réessayez dans un instant.",
      "pas-de-connexion-votre-a_b6867a": "Pas de connexion : votre annonce partira dès que possible. Suivez-la dans « Mes annonces ».",
      "plafond-de-photos-du-jou_ca27f2": "Plafond de photos du jour atteint : votre annonce partira d'elle-même dans {delai}. Suivez-la dans « Mes annonces ».",
      "trop-d-envois-en-peu-de_698efe": "Trop d'envois en peu de temps : votre annonce partira d'elle-même dans une minute. Suivez-la dans « Mes annonces ».",
      "votre-annonce-titre-n-a_48d5cf": "Votre annonce « {titre} » n'a pas pu être publiée : {raison}",
      "la-publication-a-ete-ref_2d02ef": "la publication a été refusée.",
      "en-attente-d-envoi_e8f690": "En attente d'envoi",
      "partira-des-le-retour-de_025116": "Partira dès le retour de la connexion.",
      "nouvel-essai-vers-heure_3c8fb4": "Nouvel essai vers {heure}.",
      "partira-d-elle-meme-dans_d6c5e2": "Partira d'elle-même dans {delai} (plafond de photos du jour).",
      "partira-d-elle-meme-dans_536d90": "Partira d'elle-même dans une minute.",
      "envoi-en-cours_fe95af": "Envoi en cours…",
      "non-publiee-raison_9a4782": "Non publiée : {raison}",
      "en-attente-depuis-plus-d_ad623c": "En attente depuis plus de 24 h : elle ne partira que si vous le demandez.",
      "envoyer-maintenant_8297a8": "Envoyer maintenant",
      "reprendre_d1e007": "Reprendre",
      "supprimer-cette-annonce_c871f6": "Supprimer cette annonce en attente ?",
      "elle-ne-sera-pas-publiee_0a56a3": "Elle ne sera pas publiée, et ses photos seront effacées de cet appareil.",
      "garder_fb9382": "Garder",
      "un-brouillon-est-deja-en_1cf48b": "Un brouillon est déjà en cours : publiez-le ou supprimez-le d'abord.",
      "l-envoi-n-a-pas-abouti-v_dc32f1": "L'envoi n'a pas abouti : votre annonce repartira d'elle-même. Suivez-la dans « Mes annonces ».",
      "max-annonces-attendent-d_80f3d8": "{max} annonces attendent déjà leur envoi : envoyez-en ou supprimez-en une dans « Mes annonces ». Rien n'a été publié : vos informations sont conservées.",
      "plusieurs-essais-ont-ech_bdeccd": "Plusieurs essais ont échoué : elle ne partira que si vous le demandez.",
      "cette-annonce-etait-deja_2e9365": "Cette annonce était déjà en ligne : vous la retrouvez dans « Mes annonces ».",
      "connexion-necessaire-cet_7961c9": "Connexion nécessaire : cette annonce est peut-être déjà en ligne, il faut d'abord le vérifier.",
      "votre-annonce-titre-a-et_5d0b19": "Votre annonce « {titre} » a été supprimée entre-temps : elle ne sera pas publiée à nouveau.",
      "votre-annonce-titre-est_70c485": "Votre annonce « {titre} » est publiée, sans Pulse : la période choisie était passée pendant l'attente. Aucun crédit n'a été utilisé ; vous pouvez l'activer en modifiant l'annonce.",
      "sera-effacee-de-cet-appa_d79264": "Sera effacée de cet appareil le {date}.",
      "indiquez-votre-ville_814b23": "Indiquez votre ville.",
      "votre-ville_086b71": "Votre ville",
      "pour-vous-montrer-d-abor_91d163": "Pour vous montrer d'abord les annonces près de chez vous.",
      "choisir-un-lieu_6a0f45": "Choisir un lieu",
      "ma-position_4dc16d": "Ma position",
      "position-approximative_93b118": "Position approximative",
      "votre-lieu_0c7e61": "Votre lieu",
      "les-annonces-les-plus-pr_88282e": "Les annonces les plus proches d'abord.",
      "position-actuelle_2a6934": "Position actuelle",
      "lieu-choisi_8bd18f": "Lieu choisi",
      "ville-de-votre-profil_1a0dbc": "Ville de votre profil",
      "ma-ville_5b20bf": "Ma ville",
      "au-dela-les-annonces-sui_5306d2": "Au-delà, les annonces suivent sous « Plus loin ».",
      "afficher-les-annonces_cacad4": "Afficher les annonces",
      "plus-loin_93aa25": "Plus loin",
      "a-plus-de_b9ecec": "à plus de",
      "rien-a-moins-de_370d6b": "Rien à moins de",
      "voici-les-annonces-les-p_3e16dd": "Voici les annonces les plus proches.",
      "position-refusee-autoris_e782ac": "Position refusée. Autorisez-la dans les réglages du navigateur.",
      "position-indisponible-po_7ea94a": "Position indisponible pour le moment.",
      "changer-de-lieu_ab5c40": "Changer de lieu",
      "tout-ce-qui-est-actif-au_8bb234": "Tout ce qui est actif autour de votre position",
      "position-activee_80a873": "Position activée",
      "du-plus-proche-au-plus-l_57c19d": "du plus proche au plus loin",
      "vous-avez-tout-vu_599ad6": "Vous avez tout vu",
      "voir-toutes-les-annonces_753be4": "Voir toutes les annonces",
      "avec-les-filtres-categor_d01392": "Avec les filtres : catégorie, prix, lieu",
      "un-favori-a-baisse-de-pr_102f21": "Un favori a baissé de prix",
      "votre-alerte_cb7948": "Votre alerte",
      "tout-le-fil_015da5": "Tout le fil",
      "c-est-tout-pour-les-nouv_c89754": "C'est tout pour les nouveautés",
      "depuis-tout-a-l-heure_1dc36f": "depuis tout à l'heure",
      "depuis-ce-matin_fe3114": "depuis ce matin",
      "depuis-cet-apres-midi_015d7c": "depuis cet après-midi",
      "depuis-ce-soir_051605": "depuis ce soir",
      "depuis-hier_d77eca": "depuis hier",
      "depuis-hier-soir_cf254b": "depuis hier soir",
      "depuis_2948b3": "depuis",
      "depuis-le_f64359": "depuis le",
      "nouveaute-pres-de-vous_1e9c03": "nouveauté près de vous",
      "nouveautes-pres-de-vous_f46f45": "nouveautés près de vous",
      "nouveaute_5b50c9": "nouveauté",
      "nouveautes_ed3879": "nouveautés",
      "alertes-de-recherche_c53da7": "Alertes de recherche",
      "m-alerter_10d71d": "M'alerter",
      "alerte-supprimee_8a7c55": "Alerte supprimée.",
      "precisez-votre-recherche_ffed93": "Précisez votre recherche — un mot, une catégorie, un lieu ou un prix — pour créer une alerte.",
      "alerte-creee-vous-serez_a00811": "Alerte créée : vous serez prévenu dès qu'une annonce correspond.",
      "supprimer-l-alerte_e32284": "Supprimer l'alerte",
      "jusqu-a-ce-soir_24162b": "jusqu'à ce soir",
      "jusqu-a-demain_df86eb": "jusqu'à demain",
      "encore-n-j_257524": "encore {n} j",
      "pourquoi-cette-annonce_204cc1": "Pourquoi cette annonce ?",
      "annonce-sponsorisee-son_a43703": "Annonce sponsorisée : son vendeur a choisi de la mettre en avant.",
      "mise-en-avant-par_d429bc": "Mise en avant par",
      "distance-de-votre-lieu_219616": "Distance de votre lieu",
      "remise_2dff97": "Remise",
      "au-lieu-de_f3cd50": "au lieu de",
      "le-reste-du-fil-garde-so_6f478e": "Le reste du fil garde son ordre : du plus proche au plus loin.",
      "compris_50a408": "Compris",
      "sans-photo_a82c07": "Sans photo",
      "photo-n-sur-t_ddf3cf": "Photo {n} sur {t}",
      "lire-la-video_51a234": "Lire la vidéo",
      "mettre-en-pause_432277": "Mettre en pause",
      "glissez-vers-le-haut-ann_fc040a": "Glissez vers le haut : annonce suivante",
      "glissez-de-cote-photos_0218b0": "Glissez de côté : photos",
      "annonce-precedente_8273a2": "Annonce précédente",
      "annonce-suivante_4caae8": "Annonce suivante",
      "toucher-pour-revenir_3b6241": "Toucher pour revenir",
      "photo-indisponible_3ec459": "Photo indisponible",
      "pourquoi-cet-ordre_cc3be2": "Pourquoi cet ordre ?",
      "le-fil-range-les-annonce_0e3a0e": "Le fil range les annonces ainsi, dans cet ordre :",
      "la-distance_2109b8": "La distance",
      "du-plus-proche-au-plus-l_946cf0": "Du plus proche au plus loin de votre lieu. Toujours en premier.",
      "sans-lieu-connu-cette-re_544015": "Sans lieu connu, cette règle ne joue pas.",
      "la-disponibilite_c20079": "La disponibilité",
      "les-annonces-disponibles_34b678": "Les annonces disponibles avant les réservées et les vendues.",
      "la-fraicheur_47a439": "La fraîcheur",
      "vos-centres-d-interet_3f6b3a": "Vos centres d'intérêt",
      "pas-encore-ils-se-dessin_bf9cd6": "Pas encore : ils se dessinent avec vos recherches, favoris, alertes et annonces consultées.",
      "desactives-ils-ne-jouent_e47ea7": "Désactivés : ils ne jouent plus dans l'ordre.",
      "la-confiance-du-vendeur_a1ed8f": "La confiance du vendeur",
      "les-annonces-sponsorisee_15a7d7": "Les annonces sponsorisées ont des emplacements réservés et sont toujours signalées.",
      "d-apres-vos-recherches-f_cec42e": "D'après vos recherches, favoris, alertes et annonces consultées :",
      "plus-une-annonce-est-rec_bc8fe8": "Plus une annonce est récente, plus elle monte.",
      "a-egalite-la-plus-proche_689e76": "À égalité, la plus proche, puis le vendeur le plus fiable.",
      "calcules-par-lanac-a-par_05f1ab": "Calculés par Lanac à partir de ce que vous faites dans l'application, les mêmes sur tous vos appareils. Désactivé : le fil n'en tient pas compte.",
      "vous-cherchez-en-ce-mome_411474": "Vous cherchez en ce moment :",
      "par-tranche-de-dix-carte_6f5467": "Par tranche de dix cartes : quatre d'une même rubrique au plus, deux nouveautés, une découverte — toujours dans votre rayon.",
      "le-melange_1a2286": "Le mélange",
      "mes-alertes_2eeaa2": "Mes alertes",
      "voir-les-annonces_27e42e": "Voir les annonces",
      "en-pause_9ee4ac": "En pause",
      "recevoir-les-nouveautes_1b5988": "Recevoir les nouveautés",
      "rien-de-nouveau_1394ce": "Rien de nouveau",
      "derniere-nouveaute_3b0ded": "Dernière nouveauté",
      "aucune-alerte-pour-le-mo_121205": "Aucune alerte pour le moment",
      "creez-en-une-depuis-une_b98329": "Créez-en une depuis une recherche, avec « M'alerter ».",
      "alerte-restauree_678295": "Alerte restaurée",
      "alerte-en-pause-rien-ne_5e7074": "Alerte en pause : rien ne vous sera envoyé.",
      "alerte-reactivee_1aa582": "Alerte réactivée",
      "vos-recherches-suivies-l_dec323": "Vos recherches suivies, leurs nouveautés, la pause.",
      "sur-100_098f4b": "sur 100",
      "toutes-les-annonces_8c147d": "Toutes les annonces",
      "tenir-compte-de-mes-cent_64f458": "Tenir compte de mes centres d'intérêt",
      "ajoutez-un-prix-pulse-in_ab62ab": "Ajoutez un prix Pulse inférieur au prix original.",
      "aucune-modification-a-en_273cb9": "Aucune modification à enregistrer.",
      "cette-annonce-n-existe-p_b9fec5": "Cette annonce n'existe plus.",
      "cette-duree-de-mise-en-a_6459f0": "Cette durée de mise en avant n'est pas reconnue : mettez l'application à jour.",
      "choisissez-une-date-de-f_8ca606": "Choisissez une date de fin Pulse dans le futur.",
      "la-mise-en-avant-n-a-pas_82d7bf": "La mise en avant n'a pas pu être activée. Rien n'a été compté.",
      "la-mise-en-avant-n-a-pas_c82ecc": "La mise en avant n'a pas été activée : votre annonce passe d'abord en vérification. Aucune activation n'a été comptée — vous pourrez l'activer une fois l'annonce approuvée.",
      "limite-atteinte-3-activa_21c332": "Limite atteinte : 3 activations Pulse maximum par utilisateur et par mois.",
      "seul-le-proprietaire-con_2315bd": "Seul le propriétaire connecté peut mettre en avant son annonce.",
      "seule-une-annonce-en-lig_3d32fe": "Seule une annonce en ligne peut être mise en avant. Rien n'a été activé ni compté.",
      "votre-score-de-confiance_5dcfed": "Votre score de confiance ne permet pas la mise en avant pour l'instant (minimum 30). Rien n'a été compté.",
      "l-annonce-est-engagee-av_d11623": "L'annonce est engagée avec un autre acheteur : terminez cet engagement, ou dites « Vendu à… » depuis l'annonce.",
      "cette-carte-ne-designe-p_4074cc": "Cette carte ne désigne pas une visite effectuée : dites « Vendu à… » depuis l'annonce.",
      "ce-statut-ne-correspond_50a2c8": "Ce statut ne correspond pas à l'annonce. En immobilier : « Sous compromis ».",
      "reservation-convenue-par_55dfed": "Réservation convenue par les deux parties.",
      "statut-confirme-par-les_e827f2": "Statut confirmé par les deux parties.",
      "l-acheteur-a-refuse-ce-c_9f8b58": "L'acheteur a refusé ce créneau sans en proposer un autre : proposez-en un.",
      "l-acheteur-a-refuse-sans_2befbc": "L'acheteur a refusé sans contre-proposer : cette offre est close.",
      "ce-creneau-n-est-plus-po_cde6b6": "Ce créneau n'est plus possible : choisissez-en un autre.",
      "cette-annonce-est-en-ver_377cf1": "Cette annonce est en vérification ou n'est plus en ligne : la réservation ne peut pas être acceptée pour le moment.",
      "votre-message-est-trop-l_c52c0f": "Votre message est trop long : raccourcissez-le, puis réessayez.",
      "ce-prix-n-est-pas-valabl_f7d9a4": "Ce prix n'est pas valable : un montant positif, avec deux décimales au plus.",
      "cette-duree-n-est-pas-va_c842ff": "Cette durée n'est pas valable : de 1 à 720 heures.",
      "cette-demande-n-est-pas_4febe4": "Cette demande n'est pas valable : mettez l'application à jour, puis réessayez.",
      "le-vendeur-a-passe-cette_98f606": "Le vendeur a passé cette annonce « sous compromis » : ce créneau ne peut plus être accepté.",
      "un-acheteur-tient-la-res_8e727d": "Un acheteur tient la réservation et un média de l'annonce est refusé par le contrôle : rien n'a été enregistré. Retirez ce média, puis réessayez.",
      "annonce-non-approuvee-pa_a15342": "Annonce non approuvée par LANAC à la suite d'une vérification : la réservation est annulée.",
      "annonce-non-approuvee-pa_aa256d": "Annonce non approuvée par LANAC à la suite d'une vérification : la demande de réservation est close.",
      "cette-annonce-n-est-plus_82be8d": "Cette annonce n'est plus disponible à la suite d'une vérification par LANAC",
      "annonce-indisponible_38442d": "Annonce indisponible",
      "un-acheteur-tient-la-res_69cb5e": "Un acheteur tient la réservation de cette annonce. Ne pas l'approuver annulera sa réservation, sans pénalité pour l'acheteur, et comptera comme une annulation pour le vendeur. Une réapprobation n'efface pas ce carton. Confirmer ?",
      "un-acheteur-a-demande-la_9a4b3a": "Un acheteur a demandé la réservation de cette annonce. Ne pas l'approuver clôt sa demande, sans pénalité pour personne. Confirmer ?",
      "vous-etes-partie-a-cet-e_302fd8": "Vous êtes partie à cet échange : un autre administrateur doit en décider. Rien n'a été enregistré.",
      "la-reservation-de-cette_8fa485": "La réservation de cette annonce a changé entre-temps : rien n'a été enregistré. Rechargez, puis réessayez.",
      "l-acheteur-a-confirme-le_bfabf0": "L'acheteur a confirmé le retrait : la vente doit d'abord se conclure. Rien n'a été enregistré.",
      "un-membre-agit-sur-cette_305959": "Un membre agit sur cette annonce à cet instant : rien n'a été enregistré. Réessayez dans un instant.",
      "un-acheteur-tient-la-res_7ed677": "Un acheteur tient la réservation : l'annonce n'a pas été supprimée. Passez-la d'abord en « Refusé » — sa réservation sera close et chacun prévenu —, puis supprimez-la.",
      "un-echange-est-en-cours_c98dff": "Un échange est en cours sur cette annonce : sa catégorie et son type restent ceux d'avant jusqu'à sa clôture.",
      "un-probleme-est-signale_680211": "Un problème est signalé sur la réservation de cet acheteur : réglez-le d'abord, puis refusez l'annonce.",
      "photos-a-verifier_1f42e4": "Photos à vérifier",
      "le-controle-automatique_536228": "Le contrôle automatique a signalé une photo pendant qu'un acheteur tenait l'annonce : elle est restée en ligne.",
      "photo-acceptable_25a623": "Photo acceptable",
      "photo-jugee-acceptable-l_80a0af": "Photo jugée acceptable : l'annonce sort de la file.",
      "photo-signalee_b0f403": "Photo signalée",
      "le-compromis-est-leve-pa_523633": "Le compromis est levé par le vendeur : cette réservation est close.",
      "compromis-leve_a453fe": "Compromis levé",
      "sans-suite-depuis-30-jou_5e0e4a": "Sans suite depuis 30 jours : cette étape est close.",
      "votre-annonce-est-sous-c_6eaad1": "Votre annonce est sous compromis : remettez-la « Disponible » avant d'accepter ou de contre-proposer une autre réservation.",
      "un-media-de-l-annonce-es_f1d602": "Un média de l'annonce est refusé ou attend sa vérification : rien n'a été enregistré. Retirez ce média, puis réessayez.",
      "photo-a-verifier-l-annon_b06088": "Photo à vérifier : l'annonce garde son statut pendant que l'équipe la vérifie.",
      "cette-annonce-est-sous-c_b60c8b": "Cette annonce est sous compromis avec un acheteur. Ne pas l'approuver lève le compromis, sans pénalité pour l'acheteur. Confirmer ?",
      "hors-ligne-votre-profil_233751": "Hors ligne : votre profil se modifiera de retour en ligne.",
      "votre-profil-se-met-a-jo_7ede46": "Votre profil se met à jour… Réessayez dans un instant.",
      "votre-profil-se-met-a-jo_1ac86d": "Votre profil se met à jour…",
      "hors-ligne-vous-voyez-la_0000c7": "Hors ligne — vous voyez la dernière version enregistrée."
    },
    "notif": {
      "accord-confirme_90a07e": "Accord confirmé",
      "annonce-admin-a-verifier_c8cabd": "Annonce admin à vérifier",
      "annonce-disponible_98ea2d": "Annonce disponible",
      "article-disponible-a-nouveau_2f5bbf": "Article disponible à nouveau",
      "article-vendu_925fc4": "Article vendu",
      "confirmation-apres-visite_4fa1d7": "Confirmation après visite",
      "confirmation-demandee_7cf013": "Confirmation demandée",
      "controle-media-apres-modific_036be8": "Contrôle média après modification",
      "controle-media-apres-publica_706683": "Contrôle média après publication",
      "conversation-signalee_c7daf5": "Conversation signalée",
      "creneau-accepte_3d2d87": "Créneau accepté",
      "creneau-de-retrait-refuse_2bec47": "Créneau de retrait refusé",
      "demande-d-essai-retiree_640e75": "Demande d'essai retirée",
      "demande-de-reservation-expir_ed6349": "Demande de réservation expirée",
      "demande-de-reservation-retir_41adf8": "Demande de réservation retirée",
      "demande-de-visite-retiree_027a5a": "Demande de visite retirée",
      "demande-expiree-sans-reponse_c68f80": "Demande expirée sans réponse",
      "essai-annule_10925f": "Essai annulé",
      "essai-confirme_4b0b34": "Essai confirmé",
      "message-concernant-p0_28acc2": "Message concernant « {p0} »",
      "message-de-p0_2a738e": "Message de {p0}",
      "modification-a-approuver_4ec476": "Modification à approuver",
      "modification-admin-a-verifie_a1976e": "Modification admin à vérifier",
      "nouveau-message_bc4fa3": "Nouveau message",
      "nouvelle-annonce-en-attente_9953dd": "Nouvelle annonce en attente de validation",
      "p0-malheureusement-p1-a-annu_113ac0": "{p0} · Malheureusement {p1} a annulé le rendez-vous. Merci de le recontacter pour convenir d'un nouveau rendez-vous.",
      "p0-p1-avec-p2_296043": "{p0} · {p1} avec {p2}",
      "rendez-vous-annule_07f186": "Rendez-vous annulé",
      "report-du-retrait-demande_2afea9": "Report du retrait demandé",
      "report-refuse_b63bcb": "Report refusé",
      "reservation-annulee_95a64f": "Réservation annulée",
      "reservation-refusee_240551": "Réservation refusée",
      "rythme-de-publication-a-veri_7f6b10": "Rythme de publication à vérifier",
      "signalement-recu_28a6b8": "Signalement reçu",
      "transaction-a-confirmer_d28587": "Transaction à confirmer",
      "une-demande-de-reservation-a_ce83b1": "Une demande de réservation attend votre réponse",
      "visite-confirmee_38e834": "Visite confirmée"
    },
    "plural": {
      "alertCount": {
        "one": "{count} alerte",
        "other": "{count} alertes"
      },
      "newListings": {
        "one": "{count} nouvelle",
        "other": "{count} nouvelles"
      },
      "accountCount": {
        "one": "{count} compte",
        "other": "{count} comptes"
      },
      "listingCount": {
        "one": "{count} annonce",
        "other": "{count} annonces"
      },
      "nearCount": {
        "one": "{count} annonce proche",
        "other": "{count} annonces proches"
      },
      "openCount": {
        "one": "{count} ouvert",
        "other": "{count} ouverts"
      },
      "results": {
        "one": "{count} résultat",
        "other": "{count} résultats"
      },
      "engagedRequests": {
        "one": "{count} demande de réservation envoyée attend une réponse",
        "other": "{count} demandes de réservation envoyées attendent une réponse"
      },
      "engagedAsks": {
        "one": "{count} demande ou offre en attente de réponse",
        "other": "{count} demandes ou offres en attente de réponse"
      },
      "engagedReservations": {
        "one": "{count} réservation en cours",
        "other": "{count} réservations en cours"
      },
      "engagedListings": {
        "one": "{count} annonce demandée ou réservée",
        "other": "{count} annonces demandées ou réservées"
      },
      "engagedDeals": {
        "one": "{count} transaction en cours",
        "other": "{count} transactions en cours"
      },
      "engagedRdv": {
        "one": "{count} visite ou essai à venir ou à conclure",
        "other": "{count} visites ou essais à venir ou à conclure"
      },
      "engagedOffers": {
        "one": "{count} offre acceptée, dont la suite reste à conclure",
        "other": "{count} offres acceptées, dont la suite reste à conclure"
      },
      "engagedConfirmations": {
        "one": "{count} transaction à confirmer",
        "other": "{count} transactions à confirmer"
      },
      "engagedConclusions": {
        "one": "{count} échange en attente de sa conclusion",
        "other": "{count} échanges en attente de leur conclusion"
      },
      "engagedOther": {
        "one": "{count} autre échange en cours",
        "other": "{count} autres échanges en cours"
      }
    }
  }
}
